import { TemplatePortal } from '@angular/cdk/portal';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, forwardRef, TemplateRef, Component, ChangeDetectionStrategy, ViewEncapsulation, ViewChild, NgModule } from '@angular/core';
import { Subscription, merge } from 'rxjs';
import * as i1 from '@angular/cdk/overlay';
import * as i3 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import * as i3$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { DateRange, MAT_DATE_RANGE_SELECTION_STRATEGY, DefaultMatCalendarRangeStrategy } from '@angular/material/datepicker';
import * as i5 from '@niceltd/sol/calendar';
import { WeekRangeSelectionStrategy, CalendarModule } from '@niceltd/sol/calendar';
import * as i1$1 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import * as i2 from '@angular/material/core';
import * as i6 from '@niceltd/sol/numeric-selector';
import { NumericSelectorModule } from '@niceltd/sol/numeric-selector';
import * as i7 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i8 from '@niceltd/sol/time-picker';
import { TimePickerModule } from '@niceltd/sol/time-picker';
import * as i9 from '@niceltd/sol/tabs';
import { TabsModule } from '@niceltd/sol/tabs';
import { TextInputModule } from '@niceltd/sol/text-input';
import { SvgSpriteIconModule } from '@niceltd/sol/svg-sprite-icon';
import { languageInitializerProvider } from '@niceltd/sol';
const _c0 = ["startDateTimePicker"];
const _c1 = ["endDateTimePicker"];
const _c2 = ["calendar"];
function DateRangeWrapperComponent_ng_template_0_div_1_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, DateRangeWrapperComponent_ng_template_0_div_1_div_5_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_1_div_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, DateRangeWrapperComponent_ng_template_0_div_1_div_6_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r8 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r8);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_1_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "sol-tabs", 8);
    i0.ɵɵlistener("selectedTabChange", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_tabs_selectedTabChange_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r16 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r16.onSelectedTabChange($event));
    });
    i0.ɵɵelementStart(2, "sol-tab", 9);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtemplate(5, DateRangeWrapperComponent_ng_template_0_div_1_div_5_Template, 2, 1, "div", 11)(6, DateRangeWrapperComponent_ng_template_0_div_1_div_6_Template, 2, 1, "div", 11);
    i0.ɵɵelementStart(7, "div", 12)(8, "div", 13)(9, "sol-time-picker", 14, 15);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_time_picker_ngModelChange_9_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r18 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r18.selectedStartDateTime, $event) || (ctx_r18.selectedStartDateTime = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("timeChanged", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_time_picker_timeChanged_9_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r19 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r19.timeSelection($event));
    });
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(11, "sol-tab", 16);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementStart(13, "div", 10)(14, "div", 17);
    i0.ɵɵtemplate(15, DateRangeWrapperComponent_ng_template_0_div_1_ng_container_15_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 12)(17, "div", 13)(18, "sol-time-picker", 19, 20);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_time_picker_ngModelChange_18_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r20 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r20.selectedEndDateTime, $event) || (ctx_r20.selectedEndDateTime = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("timeChanged", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_time_picker_timeChanged_18_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r21 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r21.timeSelection($event));
    });
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(20, "div", 21)(21, "div", 22)(22, "sol-button", 23);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_button_onClick_22_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r22 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r22.submitDateRange());
    });
    i0.ɵɵelementStart(23, "span", 24);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "sol-button", 25);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_button_onClick_25_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r23 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r23.cancelSlection());
    });
    i0.ɵɵelementStart(26, "span", 24);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(28, "div", 26)(29, "sol-button", 25);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_1_Template_sol_button_onClick_29_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r24 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r24.clearSelection());
    });
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", "large")("selectedIndex", ctx_r3.switchTabIndex);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 27, "startDateTabTitle"));
    i0.ɵɵproperty("isActive", ctx_r3.selectedDateRange && !ctx_r3.selectedDateRange.start);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r3.dateSingleSelectionState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dateSingleSelectionState);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("alwaysOpen", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedStartDateTime);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(12, 29, "endDateTabTitle"));
    i0.ɵɵproperty("disabled", ctx_r3.tabDisabled)("isActive", ctx_r3.selectedDateRange && !ctx_r3.selectedDateRange.end);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("alwaysOpen", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedEndDateTime);
    i0.ɵɵproperty("minTime", ctx_r3.minTime);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("size", "medium")("disabled", !ctx_r3.selectedDateRange.start || !ctx_r3.selectedDateRange.end)("ariaLabel", ctx_r3.applyText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.applyText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", "basic")("size", "medium")("ariaLabel", ctx_r3.cancelText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.cancelText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("variant", "text")("size", "medium")("ariaLabel", ctx_r3.clear);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.clear);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "div")(2, "div", 32)(3, "sol-button", 33);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template_sol_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r28 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r28.changeDays(1));
    });
    i0.ɵɵelementStart(4, "span", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "sol-button", 33);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template_sol_button_onClick_6_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r30 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r30.changeDays(6));
    });
    i0.ɵɵelementStart(7, "span", 34);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(9, "hr");
    i0.ɵɵelementStart(10, "div", 32)(11, "sol-button", 33);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template_sol_button_onClick_11_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r31 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r31.changeMonth(0));
    });
    i0.ɵɵelementStart(12, "span", 34);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "sol-button", 33);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template_sol_button_onClick_14_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r32 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r32.changeMonth(1));
    });
    i0.ɵɵelementStart(15, "span", 34);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(17, "hr");
    i0.ɵɵelementStart(18, "div", 32)(19, "sol-button", 33);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template_sol_button_onClick_19_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r33 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r33.onClickNumSelector());
    });
    i0.ɵɵelementStart(20, "span", 34);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(22, "div", 32)(23, "sol-button", 33);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template_sol_button_onClick_23_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r34 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r34.selectToday());
    });
    i0.ɵɵelementStart(24, "span", 35);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("variant", "text")("ariaLabel", ctx_r25.lastTwoDays);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r25.lastTwoDays);
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", "text")("ariaLabel", ctx_r25.lastSevenDays);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r25.lastSevenDays);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("variant", "text")("ariaLabel", ctx_r25.currentMonth);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r25.currentMonth);
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", "text")("ariaLabel", ctx_r25.previousMonth);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r25.previousMonth);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("variant", "text")("ariaLabel", ctx_r25.lastNdays);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r25.lastNdays);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("variant", "text")("ariaLabel", ctx_r25.today);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r25.today);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 36)(2, "div", 37);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 38)(5, "sol-numeric-selector", 39);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeWrapperComponent_ng_template_0_div_2_div_3_Template_sol_numeric_selector_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r36);
      const ctx_r35 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r35.lastDaysSelected, $event) || (ctx_r35.lastDaysSelected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DateRangeWrapperComponent_ng_template_0_div_2_div_3_Template_sol_numeric_selector_valueChange_5_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r37 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r37.numericSelectorValue());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 37);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 40)(9, "sol-button", 41);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_3_Template_sol_button_onClick_9_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r38 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r38.closeOverlay());
    });
    i0.ɵɵelementStart(10, "span", 42);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "sol-button", 43);
    i0.ɵɵlistener("onClick", function DateRangeWrapperComponent_ng_template_0_div_2_div_3_Template_sol_button_onClick_12_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r39 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r39.selcectNumSelectorValue());
    });
    i0.ɵɵelementStart(13, "span", 42);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r26.lastText);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r26.lastDaysSelected);
    i0.ɵɵproperty("step", 1)("min", 1)("placeholder", "1");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r26.daysText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("variant", "basic")("size", "medium");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r26.cancelText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", "medium");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r26.applyText);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "sol-calendar", 44, 45);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeWrapperComponent_ng_template_0_div_2_div_4_Template_sol_calendar_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r42);
      const ctx_r41 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r41.selectedDateRange, $event) || (ctx_r41.selectedDateRange = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("dateSelected", function DateRangeWrapperComponent_ng_template_0_div_2_div_4_Template_sol_calendar_dateSelected_2_listener($event) {
      i0.ɵɵrestoreView(_r42);
      const ctx_r43 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r43.dateSelection($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r27.type);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r27.selectedDateRange);
    i0.ɵɵproperty("min", ctx_r27.min)("max", ctx_r27.max)("daysDisabled", ctx_r27.daysDisabled)("specialDates", ctx_r27.specialDates)("startingDay", ctx_r27.startingDay);
  }
}
function DateRangeWrapperComponent_ng_template_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, DateRangeWrapperComponent_ng_template_0_div_2_div_1_Template, 26, 18, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtemplate(3, DateRangeWrapperComponent_ng_template_0_div_2_div_3_Template, 15, 11, "div", 30)(4, DateRangeWrapperComponent_ng_template_0_div_2_div_4_Template, 4, 7, "div", 30);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("no-leftpanel", !ctx_r4.displayleftPanel || ctx_r4.type === "week-selection")("with-time", ctx_r4.showTime);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.displayleftPanel && ctx_r4.type !== "week-selection");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.showNumSelector);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.showNumSelector);
  }
}
function DateRangeWrapperComponent_ng_template_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-calendar", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeWrapperComponent_ng_template_0_ng_template_3_Template_sol_calendar_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r45);
      const ctx_r44 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r44.selectedDateRange, $event) || (ctx_r44.selectedDateRange = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("dateSelected", function DateRangeWrapperComponent_ng_template_0_ng_template_3_Template_sol_calendar_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r45);
      const ctx_r46 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r46.onDateRangeSelection($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "range-selection")("min", ctx_r5.getMin())("max", ctx_r5.max)("daysDisabled", ctx_r5.daysDisabled);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r5.selectedDateRange);
    i0.ɵɵproperty("startingDay", ctx_r5.startingDay);
  }
}
function DateRangeWrapperComponent_ng_template_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-calendar", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeWrapperComponent_ng_template_0_ng_template_5_Template_sol_calendar_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r48);
      const ctx_r47 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r47.singleSelectionDate, $event) || (ctx_r47.singleSelectionDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("dateSelected", function DateRangeWrapperComponent_ng_template_0_ng_template_5_Template_sol_calendar_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r48);
      const ctx_r49 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r49.singleDateSelected($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "single-selection")("min", ctx_r7.min)("max", ctx_r7.max)("daysDisabled", ctx_r7.daysDisabled);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r7.singleSelectionDate);
    i0.ɵɵproperty("startingDay", ctx_r7.startingDay);
  }
}
function DateRangeWrapperComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, DateRangeWrapperComponent_ng_template_0_div_1_Template, 31, 31, "div", 3)(2, DateRangeWrapperComponent_ng_template_0_div_2_Template, 5, 7, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DateRangeWrapperComponent_ng_template_0_ng_template_3_Template, 1, 6, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(5, DateRangeWrapperComponent_ng_template_0_ng_template_5_Template, 1, 6, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.mode === "popover" ? "date-range-picker-wrapper-popover" : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showTime);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.showTime);
  }
}
function DateRangeWrapperComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 47);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
  }
}
function DateRangePickerComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "sol-button", 29);
    i0.ɵɵlistener("onClick", function DateRangePickerComponent_div_5_Template_sol_button_onClick_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.previousDateRange());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "sol-button", 29);
    i0.ɵɵlistener("onClick", function DateRangePickerComponent_div_5_Template_sol_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.nextDateRange());
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(36);
    const _r9 = i0.ɵɵreference(38);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 10, "previousIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r7)("disabled", ctx_r0.disabled || ctx_r0.overlayOpen || ctx_r0.selectedDateRange && ctx_r0.selectedDateRange.start && ctx_r0.minDate && ctx_r0.selectedDateRange.start <= ctx_r0.minDate || !ctx_r0.selectedDateRange || !ctx_r0.selectedDateRange.start || !ctx_r0.selectedDateRange.end || !!ctx_r0.notAvailableSelectedDateRange.startDate || !!ctx_r0.notAvailableSelectedDateRange.endDate || !!ctx_r0.invalidSelectedDateRange.endDate || !!ctx_r0.invalidSelectedDateRange.startDate || !ctx_r0.startDate && !ctx_r0.endDate);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 12, "nextIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r9)("disabled", ctx_r0.disabled || ctx_r0.overlayOpen || ctx_r0.selectedDateRange && ctx_r0.selectedDateRange.end && ctx_r0.maxDate && ctx_r0.selectedDateRange.end >= ctx_r0.maxDate || !ctx_r0.selectedDateRange || !ctx_r0.selectedDateRange.start || !ctx_r0.selectedDateRange.end || !!ctx_r0.notAvailableSelectedDateRange.startDate || !!ctx_r0.notAvailableSelectedDateRange.endDate || !!ctx_r0.invalidSelectedDateRange.endDate || !!ctx_r0.invalidSelectedDateRange.startDate || !ctx_r0.startDate && !ctx_r0.endDate);
  }
}
function DateRangePickerComponent_div_32_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "sol-button", 29);
    i0.ɵɵlistener("onClick", function DateRangePickerComponent_div_32_Template_sol_button_onClick_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.previousDateRange());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "sol-button", 29);
    i0.ɵɵlistener("onClick", function DateRangePickerComponent_div_32_Template_sol_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.nextDateRange());
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(36);
    const _r9 = i0.ɵɵreference(38);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 10, "previousIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r7)("disabled", ctx_r4.disabled || ctx_r4.overlayOpen || ctx_r4.selectedDateRange && ctx_r4.selectedDateRange.start && ctx_r4.minDate && ctx_r4.selectedDateRange.start <= ctx_r4.minDate || !ctx_r4.selectedDateRange || !ctx_r4.selectedDateRange.start || !ctx_r4.selectedDateRange.end || !!ctx_r4.notAvailableSelectedDateRange.startDate || !!ctx_r4.notAvailableSelectedDateRange.endDate || !!ctx_r4.invalidSelectedDateRange.endDate || !!ctx_r4.invalidSelectedDateRange.startDate || !ctx_r4.startDate && !ctx_r4.endDate);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 12, "nextIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r9)("disabled", ctx_r4.disabled || ctx_r4.overlayOpen || ctx_r4.selectedDateRange && ctx_r4.selectedDateRange.end && ctx_r4.maxDate && ctx_r4.selectedDateRange.end >= ctx_r4.maxDate || !ctx_r4.selectedDateRange || !ctx_r4.selectedDateRange.start || !ctx_r4.selectedDateRange.end || !!ctx_r4.notAvailableSelectedDateRange.startDate || !!ctx_r4.notAvailableSelectedDateRange.endDate || !!ctx_r4.invalidSelectedDateRange.endDate || !!ctx_r4.invalidSelectedDateRange.startDate || !ctx_r4.startDate && !ctx_r4.endDate);
  }
}
function DateRangePickerComponent_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 30);
    i0.ɵɵelement(1, "path", 31);
    i0.ɵɵelementEnd();
  }
}
function DateRangePickerComponent_ng_template_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 30);
    i0.ɵɵelement(1, "path", 32);
    i0.ɵɵelementEnd();
  }
}
const _c3 = () => ({
  updateOn: "blur"
});
const _c4 = ".sol-date-range-container .date-range-label{width:19.0625rem}.sol-date-range-container .date-range-label.with-time-picker{width:31.875rem}.sol-date-range-container .date-range-label .label-class{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:1.021rem;letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:var(--outline-offset4)}.sol-date-range-container .date-range-label .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .date-range-subcontainer{display:flex;gap:var(--outline-offset4)}.sol-date-range-container .input-container{width:19.0625rem;display:inline-flex;align-items:center;background-color:#fff;gap:1.75rem;height:2.25rem;border:.0625rem;border-style:solid;border-radius:var(--outline-offset4);border-color:var(--color-globalstate-inactive-border)}.sol-date-range-container .input-container.with-time-width{width:31.875rem}.sol-date-range-container .input-container .input-subcontainer{display:flex;align-items:center;width:15.375rem;color:var(--color-interface-text700)}.sol-date-range-container .input-container .input-subcontainer.width-time{width:28.125rem}.sol-date-range-container .input-container:hover{border-color:var(--color-globalstate-hover-border)}.sol-date-range-container .input-container:focus-within{border-color:var(--color-globalstate-active-border)}.sol-date-range-container .input-container.error-border{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .input-container.error-border:active,.sol-date-range-container .input-container.error-border:focus{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .disabled{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);pointer-events:none;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .disabled svg path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .calendar-icon{outline:none;cursor:pointer}.sol-date-range-container .calendar-icon:focus-visible{outline:.0625rem solid var(--color-globalstate-focus);outline-offset:.125rem}.sol-date-range-container .calendar-icon.svg-disabled{pointer-events:none}.sol-date-range-container .calendar-icon.svg-disabled path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .span-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .action-button-container{display:flex;gap:var(--outline-offset4);height:36px}.sol-date-range-container .read-only{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);color:var(--color-interface-text800);cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .read-only:focus-within{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .read-only:hover{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .sol-date-range-input{height:100%;width:7.75rem;border-style:none;border-width:0;box-sizing:border-box;background-color:var(--color-button-basic-normal);outline:none;margin-left:var(--outline-offset4);font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);text-align:left;color:var(--color-interface-text700);display:flex}.sol-date-range-container .sol-date-range-input.with-time{width:13.75rem}.sol-date-range-container .sol-date-range-input:read-only{cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .sol-date-range-input:read-only::placeholder{color:var(--color-interface-text800)}.sol-date-range-container .sol-date-range-input:disabled{pointer-events:var(--typography-opensans-body-body1-text-case);background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-date-range-container .sol-date-range-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .error-message{color:var(--color-button-destructive-hover);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);margin-top:.4rem;display:block}.date-range-picker-wrapper-popover{background:var(--color-button-basic-normal);border:.0625rem solid var(--color-interface-border1);box-shadow:0 var(--outline-offset4) .375rem #0000003d;border-radius:var(--radii-small-allcorners)}.date-range-picker-wrapper .date-range-container{display:flex;position:relative;width:29rem}.date-range-picker-wrapper .date-range-container.no-leftpanel{width:20.5rem}.date-range-picker-wrapper .date-range-container.with-time{width:29.75rem}.date-range-picker-wrapper .date-range-container .list-container{display:flex;flex-direction:column;justify-content:space-between;width:8.5rem;border-right:.0625rem solid var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container{margin-top:.3125rem;margin-bottom:.3125rem}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements{padding-left:.3125rem;cursor:pointer}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .span-width{width:5.625rem;text-align:left}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .today-span{width:5.625rem}.date-range-picker-wrapper .date-range-container .list-container hr{margin:0;border-style:solid;color:var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper{width:20.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container{display:flex;font-family:var(--typography-opensans-body-body3-font-family);font-weight:700;font-size:.9375rem;margin:1.5rem;width:17.5rem;height:2.375rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container .inner-container-div{text-align:center;align-items:center;display:flex;padding:.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container{display:flex;position:absolute;bottom:1.25rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class{margin-left:.75rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class .button-span-width{width:7.75rem}.date-range-picker-wrapper .date-range-time-container{width:28.75rem}.date-range-picker-wrapper .date-range-time-container .date-time-container{display:flex;position:relative}.date-range-picker-wrapper .date-range-time-container .date-time-container .calendar-container{width:17.5rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:.0625rem solid var(--color-interface-border1);width:10rem;padding:1.125rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container .timepicker{height:100%}.date-range-picker-wrapper .date-range-time-container .footer{width:100%;border-top:.0625rem solid var(--color-interface-border1);display:inline-flex;justify-content:space-between;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .clear-button{display:inline-flex;margin:18px}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons{display:inline-flex;margin:1.125rem;gap:.75rem;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons .buttons-span{width:7.125rem}\n";
class DateRangePickerDirective {
  constructor(overlay, viewContainerRef) {
    this.overlay = overlay;
    this.viewContainerRef = viewContainerRef;
    this.isOverlayOpen = false;
    this.datepickerClosingActionsSub = Subscription.EMPTY;
    this.overlayChanged = new EventEmitter();
  }
  toggleDateRangeOverlay(event) {
    event.preventDefault();
    if (this.isOverlayOpen) {
      this.destroyDatepicker();
    }
    this.openDateRangeOverlay();
  }
  openDateRangeOverlay() {
    const textinputEl = this.textInput;
    this.isOverlayOpen = true;
    this.overlayRef = this.overlay.create({
      hasBackdrop: !this.haveBackDrop,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.close(),
      positionStrategy: this.overlay.position().flexibleConnectedTo(textinputEl).withPositions([{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 8,
        offsetX: 0
      }, {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -8,
        offsetX: 0
      }])
    });
    const templatePortal = new TemplatePortal(this.dateRangeOverlayPanel.templateRef, this.viewContainerRef);
    this.overlayRef.attach(templatePortal);
    this.datepickerClosingActionsSub = this.datepickerClosingActions().subscribe(() => this.destroyDatepicker());
    document.querySelector('.mat-calendar-body-active')?.focus();
    this.overlayChanged.emit(true);
  }
  datepickerClosingActions() {
    const backdropClick$ = this.overlayRef.backdropClick();
    const detachment$ = this.overlayRef.detachments();
    const datepickerClosed = this.dateRangeOverlayPanel.closed;
    return merge(backdropClick$, detachment$, datepickerClosed);
  }
  destroyDatepicker() {
    if (!this.overlayRef || !this.isOverlayOpen) {
      return;
    }
    this.datepickerClosingActionsSub.unsubscribe();
    this.isOverlayOpen = false;
    this.overlayRef.detach();
    this.overlayChanged.emit(false);
  }
  ngOnDestroy() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
  static {
    this.ɵfac = function DateRangePickerDirective_Factory(t) {
      return new (t || DateRangePickerDirective)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DateRangePickerDirective,
      selectors: [["", "solDateRangeOverlay", ""]],
      hostBindings: function DateRangePickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DateRangePickerDirective_click_HostBindingHandler($event) {
            return ctx.toggleDateRangeOverlay($event);
          })("keydown.enter", function DateRangePickerDirective_keydown_enter_HostBindingHandler($event) {
            return ctx.toggleDateRangeOverlay($event);
          });
        }
      },
      inputs: {
        dateRangeOverlayPanel: [i0.ɵɵInputFlags.None, "solDateRangeOverlay", "dateRangeOverlayPanel"],
        textInput: [i0.ɵɵInputFlags.None, "solTextInput", "textInput"],
        haveBackDrop: "haveBackDrop"
      },
      outputs: {
        overlayChanged: "overlayChanged"
      },
      exportAs: ["solDateRangeOverlay"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangePickerDirective, [{
    type: Directive,
    args: [{
      selector: '[solDateRangeOverlay]',
      host: {
        '(click)': 'toggleDateRangeOverlay($event)',
        '(keydown.enter)': 'toggleDateRangeOverlay($event)'
      },
      exportAs: 'solDateRangeOverlay'
    }]
  }], () => [{
    type: i1.Overlay
  }, {
    type: i0.ViewContainerRef
  }], {
    dateRangeOverlayPanel: [{
      type: Input,
      args: ['solDateRangeOverlay']
    }],
    textInput: [{
      type: Input,
      args: ['solTextInput']
    }],
    haveBackDrop: [{
      type: Input
    }],
    overlayChanged: [{
      type: Output
    }]
  });
})();
class DateRangeWrapperComponent {
  constructor(cdr, translationService, _dateAdapter) {
    this.cdr = cdr;
    this.translationService = translationService;
    this._dateAdapter = _dateAdapter;
    this.daysDisabled = [];
    this.startingDay = 0;
    this.min = null;
    this.max = null;
    this.specialDates = [];
    this.displayleftPanel = false;
    this.mode = 'popover';
    this.numSelectorValue = '';
    this.showNumSelector = false;
    this.applyButtonDisabled = true;
    this.closed = new EventEmitter();
    this.dateSelected = new EventEmitter();
    this.listSelected = new EventEmitter();
    this.numericSelctorOutput = new EventEmitter();
    this.selectedMonth = new EventEmitter();
    this.disabledDateSelected = new EventEmitter();
    this.timeRangeEvent = new EventEmitter();
    this.selectedDateRange = new DateRange(null, null);
    this.switchTabIndex = 0;
    this.dateSingleSelectionState = true;
    this.tabDisabled = true;
    this.tabState = TabState.START;
    this.lastDaysSelected = 1;
    this.cancelText = this.translationService.getTranslation('cancel');
    this.applyText = this.translationService.getTranslation('apply');
    this.lastText = this.translationService.getTranslation('last');
    this.daysText = this.translationService.getTranslation('days');
    this.lastTwoDays = this.translationService.getTranslation('lastTwoDays');
    this.lastSevenDays = this.translationService.getTranslation('lastSevenDays');
    this.currentMonth = this.translationService.getTranslation('currentMonth');
    this.previousMonth = this.translationService.getTranslation('previousMonth');
    this.lastNdays = this.translationService.getTranslation('lastNdays');
    this.today = this.translationService.getTranslation('today');
    this.clear = this.translationService.getTranslation('clear');
    this._controlValueAccessorChangeFn = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
  }
  writeValue(obj) {
    if (obj) {
      this.selectedDateRange = obj;
      this._currentDateRange = obj;
      this.selectedStartDateTime = obj.start;
      this.selectedEndDateTime = obj.end;
      if (this.selectedStartDateTime && this.selectedEndDateTime) {
        this.dateSingleSelectionState = false;
      }
      this.cdr.detectChanges();
    }
  }
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  setDisabledState(isDisabled) {
    throw new Error('Method not implemented.');
  }
  dateSelection(date) {
    if (!this.showTime) {
      if (date instanceof DateRange) {
        if (date.start !== null) {
          date.start.setHours(0, 0, 0);
        }
        if (date.end !== null) {
          date.end.setHours(23, 59, 59);
        }
      }
      this.dateSelected.emit(date);
      this._controlValueAccessorChangeFn(date);
      if (this.selectedDateRange.end) {
        this.closed.emit();
      }
    }
  }
  onDateRangeSelection(dateRange) {
    if (dateRange instanceof DateRange && this.showTime) {
      if (this.tabState === TabState.START) {
        this.selectStartDate(dateRange);
      } else if (this.tabState === TabState.END) {
        this.selectEndDate(dateRange);
      }
    }
  }
  selectStartDate(dateRange) {
    const startTime = this.selectedStartDateTime;
    const startDate = dateRange.start;
    if (startTime) {
      this.setTime(startDate, startTime);
    } else {
      this.selectedStartDateTime = new Date(startDate);
    }
    this.selectedDateRange = new DateRange(new Date(startDate), this._currentDateRange?.end);
    this._currentDateRange = new DateRange(new Date(startDate), this._currentDateRange?.end);
    if (this._currentDateRange.end && dateRange.start >= this._currentDateRange.end) {
      this.updateSingleSelectionDate(dateRange);
    }
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    setTimeout(() => {
      this.startDateTimePicker?.textInputEl.textInput.nativeElement.focus();
    }, 100);
  }
  selectEndDate(dateRange) {
    if (dateRange.end === null) {
      this.endDateSelectionWithNull(dateRange);
    } else {
      this.endDateSelectionWithoutNull(dateRange);
    }
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    setTimeout(() => {
      this.endDateTimePicker?.textInputEl.textInput.nativeElement.focus();
    }, 100);
  }
  endDateSelectionWithNull(dateRange) {
    if (this.selectedEndDateTime) {
      this.setTime(dateRange.start, this.selectedEndDateTime);
    }
    this.dateSingleSelectionState = false;
    this.selectedDateRange = new DateRange(this._currentDateRange?.start, dateRange.start);
    this._currentDateRange = new DateRange(this._currentDateRange?.start, dateRange.start);
  }
  endDateSelectionWithoutNull(dateRange) {
    if (this.selectedEndDateTime) {
      this.setTime(dateRange.end, this.selectedEndDateTime);
    }
    this.selectedDateRange = new DateRange(this.selectedDateRange?.start, dateRange.end);
    this._currentDateRange = new DateRange(this.selectedDateRange?.start, dateRange.end);
    this.selectedEndDateTime = this.selectedDateRange.end;
    if (this.selectedEndDateTime && this.selectedDateRange.end) {
      this.selectedEndDateTime = this.selectedDateRange.end;
    }
  }
  updateSingleSelectionDate(dateRange) {
    this.dateSingleSelectionState = true;
    this.singleDateSelected(dateRange.start);
    this._currentDateRange = new DateRange(dateRange.start, null);
    this.selectedEndDateTime = null;
    this.applyButtonDisabled = true;
  }
  singleDateSelected(date) {
    this.singleSelectionDate = date;
    if (this.selectedStartDateTime) {
      this.setTime(new Date(date), this.selectedStartDateTime);
    }
    this.selectedStartDateTime = date;
    this.selectedDateRange = new DateRange(new Date(date), null);
    this._currentDateRange = new DateRange(new Date(date), null);
    this.dateSelected.emit(this.selectedDateRange);
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    if (this.showTime) {
      setTimeout(() => {
        this.startDateTimePicker?.textInputEl.textInput.nativeElement.focus();
      }, 100);
    }
  }
  setTime(date, dateTime) {
    if (date && dateTime) {
      date.setHours(dateTime.getHours());
      date.setMinutes(dateTime.getMinutes());
      date.setSeconds(dateTime.getSeconds());
    }
  }
  timeSelection(date) {
    if (this.tabState === TabState.START) {
      this.selectStartTime(date);
    } else if (this.tabState === TabState.END) {
      this.selectEndTime(date);
    }
  }
  selectStartTime(date) {
    if (this.selectedStartDateTime && this.selectedDateRange?.start) {
      this.setTime(this.selectedDateRange.start, this.selectedStartDateTime);
      const newStartDate = new Date(this.selectedDateRange.start);
      this.selectedDateRange = new DateRange(newStartDate, this.selectedDateRange.end);
      if (this.selectedDateRange.end && this.selectedDateRange.start && this.selectedDateRange.end <= this.selectedDateRange.start) {
        this.timeRangeEvent.emit(true);
        return;
      }
      this.timeRangeEvent.emit(false);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
      this.tabDisabled = false;
      this.cdr.detectChanges();
      this.switchTabIndex = 1;
      this.cdr.detectChanges();
    } else if (!this.daysDisabled.includes(date.getDay())) {
      this.selectableStartTimeSelection(date);
    } else {
      this.disabledDateSelected.emit();
    }
  }
  selectableStartTimeSelection(date) {
    if (this.selectedStartDateTime) {
      this.setTime(date, this.selectedStartDateTime);
    }
    this.singleSelectionDate = date;
    this.selectedStartDateTime = date;
    this.selectedDateRange = new DateRange(date, null);
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    this.tabDisabled = false;
    this.switchTabIndex = 1;
  }
  selectEndTime(date) {
    if (this.selectedEndDateTime && this.selectedStartDateTime && this.selectedDateRange.end && this.selectedDateRange.start) {
      this.setTime(this.selectedDateRange.end, this.selectedEndDateTime);
      const newEndDate = new Date(this.selectedDateRange.end);
      this.selectedDateRange = new DateRange(this.selectedDateRange?.start, new Date(newEndDate));
      this._currentDateRange = new DateRange(this._currentDateRange?.start, new Date(newEndDate));
      this.dateSingleSelectionState = false;
      this.applyButtonDisabled = false;
      if (this.selectedDateRange.end && this.selectedDateRange.start && this.selectedDateRange.end <= this.selectedDateRange.start) {
        this.timeRangeEvent.emit(true);
        return;
      }
      this.timeRangeEvent.emit(false);
      this.dateSelected.emit(this.selectedDateRange);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
    } else if (!this.daysDisabled.includes(date.getDay())) {
      this.selectableEndTimeSelection(date);
    } else {
      this.disabledDateSelected.emit();
    }
  }
  selectableEndTimeSelection(date) {
    if (this.selectedEndDateTime) {
      this.setTime(date, this.selectedEndDateTime);
    }
    this.singleSelectionDate = date;
    this.selectedEndDateTime = date;
    this.selectedDateRange = new DateRange(this.selectedDateRange.start, date);
    if (this.selectedDateRange.end && this.selectedDateRange.start && this.selectedDateRange.end <= this.selectedDateRange.start) {
      this.timeRangeEvent.emit(true);
    }
    this.applyButtonDisabled = false;
    this._controlValueAccessorChangeFn(this.selectedDateRange);
  }
  isWithinRange() {
    if (this.min && this.max) {
      const date = new Date();
      return date >= this.min && date <= this.max;
    }
    return true;
  }
  selectToday() {
    if (this.isWithinRange()) {
      this.calendarRef?.calendar._goToDateInView(new Date(), 'month');
    }
  }
  submitDateRange() {
    this._previousDateRange = this.selectedDateRange;
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    this.dateSelected.emit(this.selectedDateRange);
    this.closed.emit();
  }
  cancelSlection() {
    this.cdr.detectChanges();
    if (this.selectedDateRange && this._previousDateRange && this.selectedDateRange.start !== null) {
      this.dateSingleSelectionState = false;
      this.selectedDateRange = new DateRange(this._previousDateRange.start, this._previousDateRange.end);
      this.dateSelected.emit(this.selectedDateRange);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
      this.closed.emit('cancel');
      return;
    }
    this.selectedDateRange = new DateRange(null, null);
    this._currentDateRange = new DateRange(null, null);
    this.singleSelectionDate = null;
    this.selectedStartDateTime = null;
    this.selectedEndDateTime = null;
    this.dateSelected.emit(this.selectedDateRange);
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    this.closed.emit('cancel');
  }
  clearSelection() {
    this.dateSingleSelectionState = true;
    this.selectedDateRange = new DateRange(null, null);
    this._currentDateRange = new DateRange(null, null);
    this._previousDateRange = new DateRange(null, null);
    this.singleSelectionDate = null;
    this.selectedStartDateTime = null;
    this.selectedEndDateTime = null;
    this.switchTabIndex = 0;
    this.tabDisabled = true;
    this.applyButtonDisabled = true;
    this.dateSelected.emit(this.selectedDateRange);
    this._controlValueAccessorChangeFn(this.selectedDateRange);
    this.closed.emit('clear');
  }
  onClickNumSelector() {
    this.showNumSelector = !this.showNumSelector;
  }
  changeDays(value) {
    if (this.showNumSelector) {
      this.showNumSelector = !this.showNumSelector;
    }
    this.listSelected.emit(value);
    this.closed.emit();
  }
  changeMonth(value) {
    if (this.showNumSelector) {
      this.showNumSelector = !this.showNumSelector;
    }
    this.selectedMonth.emit(value);
    this.closed.emit();
  }
  numericSelectorValue() {
    this.numSelectorValue = (this.lastDaysSelected - 1).toString();
  }
  selcectNumSelectorValue() {
    this.numericSelctorOutput.emit(Number(this.numSelectorValue));
    this.showNumSelector = !this.showNumSelector;
    this.closed.emit();
  }
  closeOverlay() {
    this.showNumSelector = !this.showNumSelector;
    this.closed.emit();
  }
  onSelectedTabChange(event) {
    if (event.index === 0) {
      this.tabState = TabState.START;
    } else {
      this.tabState = TabState.END;
    }
  }
  getMin() {
    if (this.tabState === TabState.END && this.selectedDateRange && this.selectedDateRange.start) {
      return this.selectedDateRange.start;
    }
    return this.min;
  }
  static {
    this.ɵfac = function DateRangeWrapperComponent_Factory(t) {
      return new (t || DateRangeWrapperComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.TranslationService), i0.ɵɵdirectiveInject(i2.DateAdapter));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateRangeWrapperComponent,
      selectors: [["sol-date-range-wrapper"]],
      viewQuery: function DateRangeWrapperComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.startDateTimePicker = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endDateTimePicker = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarRef = _t.first);
        }
      },
      inputs: {
        daysDisabled: "daysDisabled",
        startingDay: "startingDay",
        min: "min",
        max: "max",
        specialDates: "specialDates",
        displayleftPanel: "displayleftPanel",
        showTime: "showTime",
        type: "type",
        overlayState: "overlayState",
        mode: "mode"
      },
      outputs: {
        closed: "closed",
        dateSelected: "dateSelected",
        listSelected: "listSelected",
        numericSelctorOutput: "numericSelctorOutput",
        selectedMonth: "selectedMonth",
        disabledDateSelected: "disabledDateSelected",
        timeRangeEvent: "timeRangeEvent"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateRangeWrapperComponent),
        multi: true
      }, {
        provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
        useFactory: component => component.type === 'range-selection' ? new DefaultMatCalendarRangeStrategy(component._dateAdapter) : new WeekRangeSelectionStrategy(component._dateAdapter),
        deps: [DateRangeWrapperComponent]
      }])],
      decls: 3,
      vars: 1,
      consts: [["daterange", ""], [3, "ngTemplateOutlet", 4, "ngIf"], [1, "date-range-picker-wrapper", 3, "ngClass"], ["class", "date-range-time-container", 4, "ngIf"], ["class", "date-range-container", 3, "no-leftpanel", "with-time", 4, "ngIf"], ["rangeSelection", ""], ["singleSelection", ""], [1, "date-range-time-container"], [3, "size", "selectedIndex", "selectedTabChange"], [3, "title", "isActive"], [1, "date-time-container"], ["class", "calendar-container", 4, "ngIf"], [1, "timepicker-container"], [1, "timepicker"], [3, "alwaysOpen", "ngModel", "ngModelChange", "timeChanged"], ["startDateTimePicker", ""], [3, "title", "disabled", "isActive"], [1, "calendar-container"], [4, "ngTemplateOutlet"], [3, "alwaysOpen", "ngModel", "minTime", "ngModelChange", "timeChanged"], ["endDateTimePicker", ""], [1, "footer"], [1, "footer-buttons"], [3, "size", "disabled", "ariaLabel", "onClick"], [1, "buttons-span"], [3, "variant", "size", "ariaLabel", "onClick"], [1, "clear-button"], [1, "date-range-container"], ["class", "list-container", 4, "ngIf"], [1, "sol-calender-wrapper"], [4, "ngIf"], [1, "list-container"], [1, "list-sub-container"], [1, "list-elements", 3, "variant", "ariaLabel", "onClick"], [1, "span-width"], [1, "today-span"], [1, "numeric-selector-container"], [1, "inner-container-div"], [2, "width", "60px"], [3, "ngModel", "step", "min", "placeholder", "ngModelChange", "valueChange"], [1, "buttons-container"], [1, "button-class", 3, "variant", "size", "onClick"], [1, "button-span-width"], [1, "button-class", 3, "size", "onClick"], [3, "type", "ngModel", "min", "max", "daysDisabled", "specialDates", "startingDay", "ngModelChange", "dateSelected"], ["calendar", ""], [3, "type", "min", "max", "daysDisabled", "ngModel", "startingDay", "ngModelChange", "dateSelected"], [3, "ngTemplateOutlet"]],
      template: function DateRangeWrapperComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DateRangeWrapperComponent_ng_template_0_Template, 7, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, DateRangeWrapperComponent_ng_container_2_Template, 1, 1, "ng-container", 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.mode === "inline");
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, i3$1.NgControlStatus, i3$1.NgModel, i5.CalendarComponent, i6.NumericSelectorComponent, i7.ButtonComponent, i8.TimePickerComponent, i9.TabsComponent, i9.TabComponent, i1$1.TranslationPipe],
      styles: [".sol-date-range-container .date-range-label{width:19.0625rem}.sol-date-range-container .date-range-label.with-time-picker{width:31.875rem}.sol-date-range-container .date-range-label .label-class{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:1.021rem;letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:var(--outline-offset4)}.sol-date-range-container .date-range-label .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .date-range-subcontainer{display:flex;gap:var(--outline-offset4)}.sol-date-range-container .input-container{width:19.0625rem;display:inline-flex;align-items:center;background-color:#fff;gap:1.75rem;height:2.25rem;border:.0625rem;border-style:solid;border-radius:var(--outline-offset4);border-color:var(--color-globalstate-inactive-border)}.sol-date-range-container .input-container.with-time-width{width:31.875rem}.sol-date-range-container .input-container .input-subcontainer{display:flex;align-items:center;width:15.375rem;color:var(--color-interface-text700)}.sol-date-range-container .input-container .input-subcontainer.width-time{width:28.125rem}.sol-date-range-container .input-container:hover{border-color:var(--color-globalstate-hover-border)}.sol-date-range-container .input-container:focus-within{border-color:var(--color-globalstate-active-border)}.sol-date-range-container .input-container.error-border{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .input-container.error-border:active,.sol-date-range-container .input-container.error-border:focus{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .disabled{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);pointer-events:none;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .disabled svg path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .calendar-icon{outline:none;cursor:pointer}.sol-date-range-container .calendar-icon:focus-visible{outline:.0625rem solid var(--color-globalstate-focus);outline-offset:.125rem}.sol-date-range-container .calendar-icon.svg-disabled{pointer-events:none}.sol-date-range-container .calendar-icon.svg-disabled path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .span-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .action-button-container{display:flex;gap:var(--outline-offset4);height:36px}.sol-date-range-container .read-only{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);color:var(--color-interface-text800);cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .read-only:focus-within{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .read-only:hover{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .sol-date-range-input{height:100%;width:7.75rem;border-style:none;border-width:0;box-sizing:border-box;background-color:var(--color-button-basic-normal);outline:none;margin-left:var(--outline-offset4);font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);text-align:left;color:var(--color-interface-text700);display:flex}.sol-date-range-container .sol-date-range-input.with-time{width:13.75rem}.sol-date-range-container .sol-date-range-input:read-only{cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .sol-date-range-input:read-only::placeholder{color:var(--color-interface-text800)}.sol-date-range-container .sol-date-range-input:disabled{pointer-events:var(--typography-opensans-body-body1-text-case);background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-date-range-container .sol-date-range-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .error-message{color:var(--color-button-destructive-hover);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);margin-top:.4rem;display:block}.date-range-picker-wrapper-popover{background:var(--color-button-basic-normal);border:.0625rem solid var(--color-interface-border1);box-shadow:0 var(--outline-offset4) .375rem #0000003d;border-radius:var(--radii-small-allcorners)}.date-range-picker-wrapper .date-range-container{display:flex;position:relative;width:29rem}.date-range-picker-wrapper .date-range-container.no-leftpanel{width:20.5rem}.date-range-picker-wrapper .date-range-container.with-time{width:29.75rem}.date-range-picker-wrapper .date-range-container .list-container{display:flex;flex-direction:column;justify-content:space-between;width:8.5rem;border-right:.0625rem solid var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container{margin-top:.3125rem;margin-bottom:.3125rem}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements{padding-left:.3125rem;cursor:pointer}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .span-width{width:5.625rem;text-align:left}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .today-span{width:5.625rem}.date-range-picker-wrapper .date-range-container .list-container hr{margin:0;border-style:solid;color:var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper{width:20.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container{display:flex;font-family:var(--typography-opensans-body-body3-font-family);font-weight:700;font-size:.9375rem;margin:1.5rem;width:17.5rem;height:2.375rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container .inner-container-div{text-align:center;align-items:center;display:flex;padding:.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container{display:flex;position:absolute;bottom:1.25rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class{margin-left:.75rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class .button-span-width{width:7.75rem}.date-range-picker-wrapper .date-range-time-container{width:28.75rem}.date-range-picker-wrapper .date-range-time-container .date-time-container{display:flex;position:relative}.date-range-picker-wrapper .date-range-time-container .date-time-container .calendar-container{width:17.5rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:.0625rem solid var(--color-interface-border1);width:10rem;padding:1.125rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container .timepicker{height:100%}.date-range-picker-wrapper .date-range-time-container .footer{width:100%;border-top:.0625rem solid var(--color-interface-border1);display:inline-flex;justify-content:space-between;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .clear-button{display:inline-flex;margin:18px}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons{display:inline-flex;margin:1.125rem;gap:.75rem;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons .buttons-span{width:7.125rem}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangeWrapperComponent, [{
    type: Component,
    args: [{
      selector: 'sol-date-range-wrapper',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateRangeWrapperComponent),
        multi: true
      }, {
        provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
        useFactory: component => component.type === 'range-selection' ? new DefaultMatCalendarRangeStrategy(component._dateAdapter) : new WeekRangeSelectionStrategy(component._dateAdapter),
        deps: [DateRangeWrapperComponent]
      }],
      template: "<ng-template #daterange>\n  <div class=\"date-range-picker-wrapper\" [ngClass]=\"mode === 'popover' ? 'date-range-picker-wrapper-popover' : ''\">\n    <div *ngIf=\"showTime\" class=\"date-range-time-container\">\n      <sol-tabs [size]=\"'large'\" [selectedIndex]=\"switchTabIndex\" (selectedTabChange)=\"onSelectedTabChange($event)\">\n        <sol-tab title=\"{{ 'startDateTabTitle' | translate }}\" [isActive]=\"selectedDateRange && !selectedDateRange.start\">\n          <div class=\"date-time-container\">\n            <div *ngIf=\"!dateSingleSelectionState\" class=\"calendar-container\">\n              <ng-container *ngTemplateOutlet=\"rangeSelection\"></ng-container>\n            </div>\n            <div *ngIf=\"dateSingleSelectionState\" class=\"calendar-container\">\n              <ng-container *ngTemplateOutlet=\"singleSelection\"></ng-container>\n            </div>\n            <div class=\"timepicker-container\">\n              <div class=\"timepicker\">\n                <sol-time-picker\n                  #startDateTimePicker\n                  [alwaysOpen]=\"true\"\n                  [(ngModel)]=\"selectedStartDateTime\"\n                  (timeChanged)=\"timeSelection($event)\"\n                ></sol-time-picker>\n              </div>\n            </div>\n          </div>\n        </sol-tab>\n        <sol-tab title=\"{{ 'endDateTabTitle' | translate }}\" [disabled]=\"tabDisabled\" [isActive]=\"selectedDateRange && !selectedDateRange.end\">\n          <div class=\"date-time-container\">\n            <div class=\"calendar-container\">\n              <ng-container *ngTemplateOutlet=\"rangeSelection\"></ng-container>\n            </div>\n            <div class=\"timepicker-container\">\n              <div class=\"timepicker\">\n                <sol-time-picker\n                  #endDateTimePicker\n                  [alwaysOpen]=\"true\"\n                  [(ngModel)]=\"selectedEndDateTime\"\n                  [minTime]=\"minTime\"\n                  (timeChanged)=\"timeSelection($event)\"\n                ></sol-time-picker>\n              </div>\n            </div>\n          </div>\n        </sol-tab>\n      </sol-tabs>\n      <div class=\"footer\">\n        <div class=\"footer-buttons\">\n          <sol-button\n            [size]=\"'medium'\"\n            [disabled]=\"!selectedDateRange.start || !selectedDateRange.end\"\n            (onClick)=\"submitDateRange()\"\n            [ariaLabel]=\"applyText\"\n            ><span class=\"buttons-span\">{{ applyText }}</span></sol-button\n          >\n          <sol-button [variant]=\"'basic'\" [size]=\"'medium'\" (onClick)=\"cancelSlection()\" [ariaLabel]=\"cancelText\"\n            ><span class=\"buttons-span\">{{ cancelText }}</span></sol-button\n          >\n        </div>\n        <div class=\"clear-button\">\n          <sol-button [variant]=\"'text'\" [size]=\"'medium'\" (onClick)=\"clearSelection()\" [ariaLabel]=\"clear\">{{ clear }}</sol-button>\n        </div>\n      </div>\n    </div>\n    <div\n      class=\"date-range-container\"\n      [class.no-leftpanel]=\"!displayleftPanel || type === 'week-selection'\"\n      [class.with-time]=\"showTime\"\n      *ngIf=\"!showTime\"\n    >\n      <div class=\"list-container\" *ngIf=\"displayleftPanel && type !== 'week-selection'\">\n        <div>\n          <div class=\"list-sub-container\">\n            <sol-button [variant]=\"'text'\" class=\"list-elements\" (onClick)=\"changeDays(1)\" [ariaLabel]=\"lastTwoDays\"\n              ><span class=\"span-width\">{{ lastTwoDays }}</span></sol-button\n            >\n            <sol-button [variant]=\"'text'\" class=\"list-elements\" (onClick)=\"changeDays(6)\" [ariaLabel]=\"lastSevenDays\"\n              ><span class=\"span-width\">{{ lastSevenDays }}</span></sol-button\n            >\n          </div>\n          <hr />\n          <div class=\"list-sub-container\">\n            <sol-button [variant]=\"'text'\" class=\"list-elements\" (onClick)=\"changeMonth(0)\" [ariaLabel]=\"currentMonth\"\n              ><span class=\"span-width\">{{ currentMonth }}</span></sol-button\n            >\n            <sol-button [variant]=\"'text'\" class=\"list-elements\" (onClick)=\"changeMonth(1)\" [ariaLabel]=\"previousMonth\"\n              ><span class=\"span-width\">{{ previousMonth }}</span></sol-button\n            >\n          </div>\n          <hr />\n          <div class=\"list-sub-container\">\n            <sol-button [variant]=\"'text'\" class=\"list-elements\" (onClick)=\"onClickNumSelector()\" [ariaLabel]=\"lastNdays\"\n              ><span class=\"span-width\">{{ lastNdays }}</span></sol-button\n            >\n          </div>\n        </div>\n        <div class=\"list-sub-container\">\n          <sol-button [variant]=\"'text'\" class=\"list-elements\" (onClick)=\"selectToday()\" [ariaLabel]=\"today\"\n            ><span class=\"today-span\">{{ today }}</span></sol-button\n          >\n        </div>\n      </div>\n      <div class=\"sol-calender-wrapper\">\n        <div *ngIf=\"showNumSelector\">\n          <div class=\"numeric-selector-container\">\n            <div class=\"inner-container-div\">{{ lastText }}</div>\n            <div style=\"width: 60px\">\n              <sol-numeric-selector\n                [(ngModel)]=\"lastDaysSelected\"\n                [step]=\"1\"\n                [min]=\"1\"\n                [placeholder]=\"'1'\"\n                (valueChange)=\"numericSelectorValue()\"\n              ></sol-numeric-selector>\n            </div>\n            <div class=\"inner-container-div\">{{ daysText }}</div>\n          </div>\n          <div class=\"buttons-container\">\n            <sol-button [variant]=\"'basic'\" class=\"button-class\" [size]=\"'medium'\" (onClick)=\"closeOverlay()\"\n              ><span class=\"button-span-width\">{{ cancelText }}</span></sol-button\n            >\n            <sol-button (onClick)=\"selcectNumSelectorValue()\" class=\"button-class\" [size]=\"'medium'\"\n              ><span class=\"button-span-width\">{{ applyText }}</span></sol-button\n            >\n          </div>\n        </div>\n        <div *ngIf=\"!showNumSelector\">\n          <div>\n            <sol-calendar\n              #calendar\n              [type]=\"type\"\n              [(ngModel)]=\"selectedDateRange\"\n              (dateSelected)=\"dateSelection($event)\"\n              [min]=\"min\"\n              [max]=\"max\"\n              [daysDisabled]=\"daysDisabled\"\n              [specialDates]=\"specialDates\"\n              [startingDay]=\"startingDay\"\n            ></sol-calendar>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <ng-template #rangeSelection>\n    <sol-calendar\n      [type]=\"'range-selection'\"\n      [min]=\"getMin()\"\n      [max]=\"max\"\n      [daysDisabled]=\"daysDisabled\"\n      [(ngModel)]=\"selectedDateRange\"\n      [startingDay]=\"startingDay\"\n      (dateSelected)=\"onDateRangeSelection($event)\"\n    ></sol-calendar>\n  </ng-template>\n  <ng-template #singleSelection>\n    <sol-calendar\n      [type]=\"'single-selection'\"\n      [min]=\"min\"\n      [max]=\"max\"\n      [daysDisabled]=\"daysDisabled\"\n      [(ngModel)]=\"singleSelectionDate\"\n      [startingDay]=\"startingDay\"\n      (dateSelected)=\"singleDateSelected($event)\"\n    ></sol-calendar>\n  </ng-template>\n</ng-template>\n<ng-container *ngIf=\"mode === 'inline'\" [ngTemplateOutlet]=\"daterange\"></ng-container>\n",
      styles: [".sol-date-range-container .date-range-label{width:19.0625rem}.sol-date-range-container .date-range-label.with-time-picker{width:31.875rem}.sol-date-range-container .date-range-label .label-class{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:1.021rem;letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:var(--outline-offset4)}.sol-date-range-container .date-range-label .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .date-range-subcontainer{display:flex;gap:var(--outline-offset4)}.sol-date-range-container .input-container{width:19.0625rem;display:inline-flex;align-items:center;background-color:#fff;gap:1.75rem;height:2.25rem;border:.0625rem;border-style:solid;border-radius:var(--outline-offset4);border-color:var(--color-globalstate-inactive-border)}.sol-date-range-container .input-container.with-time-width{width:31.875rem}.sol-date-range-container .input-container .input-subcontainer{display:flex;align-items:center;width:15.375rem;color:var(--color-interface-text700)}.sol-date-range-container .input-container .input-subcontainer.width-time{width:28.125rem}.sol-date-range-container .input-container:hover{border-color:var(--color-globalstate-hover-border)}.sol-date-range-container .input-container:focus-within{border-color:var(--color-globalstate-active-border)}.sol-date-range-container .input-container.error-border{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .input-container.error-border:active,.sol-date-range-container .input-container.error-border:focus{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .disabled{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);pointer-events:none;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .disabled svg path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .calendar-icon{outline:none;cursor:pointer}.sol-date-range-container .calendar-icon:focus-visible{outline:.0625rem solid var(--color-globalstate-focus);outline-offset:.125rem}.sol-date-range-container .calendar-icon.svg-disabled{pointer-events:none}.sol-date-range-container .calendar-icon.svg-disabled path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .span-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .action-button-container{display:flex;gap:var(--outline-offset4);height:36px}.sol-date-range-container .read-only{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);color:var(--color-interface-text800);cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .read-only:focus-within{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .read-only:hover{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .sol-date-range-input{height:100%;width:7.75rem;border-style:none;border-width:0;box-sizing:border-box;background-color:var(--color-button-basic-normal);outline:none;margin-left:var(--outline-offset4);font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);text-align:left;color:var(--color-interface-text700);display:flex}.sol-date-range-container .sol-date-range-input.with-time{width:13.75rem}.sol-date-range-container .sol-date-range-input:read-only{cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .sol-date-range-input:read-only::placeholder{color:var(--color-interface-text800)}.sol-date-range-container .sol-date-range-input:disabled{pointer-events:var(--typography-opensans-body-body1-text-case);background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-date-range-container .sol-date-range-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .error-message{color:var(--color-button-destructive-hover);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);margin-top:.4rem;display:block}.date-range-picker-wrapper-popover{background:var(--color-button-basic-normal);border:.0625rem solid var(--color-interface-border1);box-shadow:0 var(--outline-offset4) .375rem #0000003d;border-radius:var(--radii-small-allcorners)}.date-range-picker-wrapper .date-range-container{display:flex;position:relative;width:29rem}.date-range-picker-wrapper .date-range-container.no-leftpanel{width:20.5rem}.date-range-picker-wrapper .date-range-container.with-time{width:29.75rem}.date-range-picker-wrapper .date-range-container .list-container{display:flex;flex-direction:column;justify-content:space-between;width:8.5rem;border-right:.0625rem solid var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container{margin-top:.3125rem;margin-bottom:.3125rem}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements{padding-left:.3125rem;cursor:pointer}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .span-width{width:5.625rem;text-align:left}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .today-span{width:5.625rem}.date-range-picker-wrapper .date-range-container .list-container hr{margin:0;border-style:solid;color:var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper{width:20.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container{display:flex;font-family:var(--typography-opensans-body-body3-font-family);font-weight:700;font-size:.9375rem;margin:1.5rem;width:17.5rem;height:2.375rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container .inner-container-div{text-align:center;align-items:center;display:flex;padding:.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container{display:flex;position:absolute;bottom:1.25rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class{margin-left:.75rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class .button-span-width{width:7.75rem}.date-range-picker-wrapper .date-range-time-container{width:28.75rem}.date-range-picker-wrapper .date-range-time-container .date-time-container{display:flex;position:relative}.date-range-picker-wrapper .date-range-time-container .date-time-container .calendar-container{width:17.5rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:.0625rem solid var(--color-interface-border1);width:10rem;padding:1.125rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container .timepicker{height:100%}.date-range-picker-wrapper .date-range-time-container .footer{width:100%;border-top:.0625rem solid var(--color-interface-border1);display:inline-flex;justify-content:space-between;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .clear-button{display:inline-flex;margin:18px}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons{display:inline-flex;margin:1.125rem;gap:.75rem;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons .buttons-span{width:7.125rem}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.TranslationService
  }, {
    type: i2.DateAdapter
  }], {
    daysDisabled: [{
      type: Input
    }],
    startingDay: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    specialDates: [{
      type: Input
    }],
    displayleftPanel: [{
      type: Input
    }],
    showTime: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    overlayState: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    templateRef: [{
      type: ViewChild,
      args: [TemplateRef]
    }],
    closed: [{
      type: Output
    }],
    dateSelected: [{
      type: Output
    }],
    listSelected: [{
      type: Output
    }],
    numericSelctorOutput: [{
      type: Output
    }],
    selectedMonth: [{
      type: Output
    }],
    disabledDateSelected: [{
      type: Output
    }],
    timeRangeEvent: [{
      type: Output
    }],
    startDateTimePicker: [{
      type: ViewChild,
      args: ['startDateTimePicker']
    }],
    endDateTimePicker: [{
      type: ViewChild,
      args: ['endDateTimePicker']
    }],
    calendarRef: [{
      type: ViewChild,
      args: ['calendar', {
        static: false
      }]
    }]
  });
})();
var TabState;
(function (TabState) {
  TabState[TabState["START"] = 0] = "START";
  TabState[TabState["END"] = 1] = "END";
})(TabState || (TabState = {}));
class DateRangePickerComponent {
  constructor(cdr, translationService) {
    this.cdr = cdr;
    this.translationService = translationService;
    this.format = '';
    this.displayleftPanel = false;
    this.minDate = null;
    this.maxDate = null;
    this.daysDisabled = [];
    this.specialDates = [];
    this.disabled = false;
    this.readonly = false;
    this.startingDay = 0;
    this.type = 'range-selection';
    this.errorMessages = {
      currentErrorMsg: {
        errorMsg: '',
        dateType: null
      },
      prevErrorMsg: {
        errorMsg: '',
        dateType: null
      }
    };
    this.showpanel = false;
    this.showTime = false;
    this.overlayOpen = false;
    this.timeRegex = /\bh:mm\b|\bhh:mm\b|\bhh:mm:ss\b/;
    this.dateRegex = /^d{1,2}[./\s]M{1,4}[./\s]y{1,4}$/i; // match date formats like 'dd/MM/yyyy', 'd.MM.yy', 'd M y', etc.
    this.notAvailableSelectedDateRange = {
      endDate: null,
      startDate: null
    };
    this.disabledSelectedDateRange = {
      endDate: null,
      startDate: null
    };
    this.invalidSelectedDateRange = {
      startDate: null,
      endDate: null
    };
    this.currentStartDate = '';
    this.spaceForStartDate = '';
    this.spaceForEndDate = '';
    this.currentEndDate = '';
    this.lastUpdatedEndDate = '';
    this.lastUpdatedStartDate = '';
    this.invalidDate = this.translationService.getTranslation('invalidDate');
    this.outOfRange = this.translationService.getTranslation('outOfRange');
    this.notValidDateRange = this.translationService.getTranslation('notValidDateRange');
    this.disabledDate = this.translationService.getTranslation('selectAvailableDate');
    this.invalidDateTime = this.translationService.getTranslation('invalidDateTime');
    this.selectEndDateError = this.translationService.getTranslation('selectEndDateError');
    this.dateRangeLabel = this.translationService.getTranslation('dateRangeLabel');
    this.selectStartDateError = this.translationService.getTranslation('selectStartDateError');
    this._controlValueAccessorChangeFn = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
  }
  ngOnInit() {
    if (this.timeRegex.test(this.format)) {
      this.showTime = true;
    }
  }
  writeValue(obj) {
    if (obj) {
      if (obj.start && !this.isDisabled(obj.start, "startDate" /* DATE_TYPE.START */)) {
        if (this.checkValidity(obj.start)) {
          this.setErrorStateWhenDateHasError(this.invalidDate, "startDate" /* DATE_TYPE.START */);
          return;
        } else {
          this.lastUpdatedStartDate = new DatePipe(navigator.language).transform(obj.start, this.format);
          this.setErrorStateWhenDateHasNoError(this.invalidDate, "startDate" /* DATE_TYPE.START */);
        }
      }
      if (obj.end && !this.isDisabled(obj.end, "endDate" /* DATE_TYPE.END */)) {
        if (this.checkValidity(obj.end)) {
          this.setErrorStateWhenDateHasError(this.invalidDate, "endDate" /* DATE_TYPE.END */);
          return;
        } else {
          this.setErrorStateWhenDateHasNoError(this.invalidDate, "endDate" /* DATE_TYPE.END */);
          this.lastUpdatedEndDate = new DatePipe(navigator.language).transform(obj.end, this.format);
          const endDate = new Date(obj.end);
          obj = new DateRange(obj.start, this.setEndOfDay(endDate));
        }
      }
      this.selectedDateRange = obj;
      this._controlValueAccessorChangeFn(this.selectedDateRange);
      this.cdr.detectChanges();
    }
  }
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  checkValidity(date) {
    return this.minDate && date < this.minDate || this.maxDate && date > this.maxDate;
  }
  isValidDate(dateString, dateType) {
    try {
      new Intl.DateTimeFormat().format(this.getDateToValidate(dateString));
      this.setErrorStateWhenDateHasNoError(this.invalidDate, dateType);
      this.invalidSelectedDateRange[dateType] = null;
      return true;
    } catch (e) {
      this.setErrorStateWhenDateHasError(this.invalidDate, dateType);
      this.invalidSelectedDateRange[dateType] = dateString;
      return false;
    }
  }
  get startDate() {
    if (!this.lastUpdatedStartDate && this.selectedDateRange && !this.selectedDateRange.start || !this.currentStartDate) {
      this.updateStartDate();
    }
    return this.currentStartDate === '' ? this.currentStartDate : this.currentStartDate + this.spaceForStartDate;
  }
  set startDate(date) {
    this.lastUpdatedStartDate = date;
    if (date) {
      if (this.isValidDate(date, "startDate" /* DATE_TYPE.START */)) {
        if (!this.selectedDateRange) {
          this.handleSelectedDateRangeNotSet(date);
        } else {
          this.handleSelectedDateRangeSet(date);
        }
      }
    } else {
      this.handleEmptyStartDate();
    }
  }
  get endDate() {
    if (!this.lastUpdatedEndDate && this.selectedDateRange && !this.selectedDateRange.end || !this.currentEndDate) {
      this.updateEndDate();
    }
    return this.currentEndDate === '' ? this.currentEndDate : this.currentEndDate + this.spaceForEndDate;
  }
  set endDate(date) {
    this.lastUpdatedEndDate = date;
    if (date) {
      if (this.isValidDate(date, "endDate" /* DATE_TYPE.END */)) {
        if (!this.selectedDateRange) {
          this.handleSelectedDateRangeEndNotSet(date);
        } else {
          this.handleSelectedDateRangeEndSet(date);
        }
      }
    } else {
      this.handleEmptyEndDate();
    }
  }
  setEndOfDay(date) {
    date.setHours(23, 59, 59);
    return date;
  }
  setStartOfDay(date) {
    date.setHours(0, 0, 0);
    return date;
  }
  getStartDateToValidate() {
    return this.getDateToValidate(this.lastUpdatedStartDate || '');
  }
  getEndDateToValidate() {
    return this.setEndOfDay(this.getDateToValidate(this.lastUpdatedEndDate || ''));
  }
  getDateWhenFormatMonthInTheMiddle(dateString, delimiter = '/') {
    // DD/MM/YYYY, D MM YYYY, DD.MMM.YY format
    delimiter = delimiter === null ? '/' : delimiter;
    const [day, month, year] = dateString.split(delimiter).map(Number);
    return new Date(year, month - 1, day);
  }
  getDateToValidate(dateString) {
    if (this.dateRegex.test(this.format)) {
      const match = dateString.match(/[^0-9]/);
      const delimiter = match ? match[0] : null;
      return this.getDateWhenFormatMonthInTheMiddle(dateString, delimiter);
    }
    return new Date(dateString);
  }
  updateStartDate() {
    // If the DateRange.start date is invalid, set the current start date to the invalid date
    if (this.invalidSelectedDateRange.startDate) {
      this.currentStartDate = this.invalidSelectedDateRange.startDate;
      return;
    }
    // If there's no last updated start date, set the current start date to an empty string
    if (!this.lastUpdatedStartDate) {
      this.currentStartDate = '';
      return;
    }
    // Get the start date
    const date = this.disabledSelectedDateRange?.startDate || this.notAvailableSelectedDateRange?.startDate || this.selectedDateRange?.start;
    // If there's no date, set the current start date to an empty string
    if (!date || isNaN(date.getTime())) {
      this.currentStartDate = '';
      return;
    }
    const newStartDate = new DatePipe(navigator.language).transform(date, this.format);
    this.spaceForStartDate = this.currentStartDate === newStartDate ? this.spaceForStartDate === ' ' ? '' : ' ' : '';
    this.currentStartDate = newStartDate;
  }
  updateEndDate() {
    // If the DateRange.end date is invalid, set the current end date to the invalid date
    if (this.invalidSelectedDateRange.endDate) {
      this.currentEndDate = this.invalidSelectedDateRange.endDate;
      return;
    }
    // If there's no last updated end date, set the current end date to an empty string
    if (!this.lastUpdatedEndDate) {
      this.currentEndDate = '';
      return;
    }
    // Get the end date
    const date = this.disabledSelectedDateRange?.endDate || this.notAvailableSelectedDateRange?.endDate || this.selectedDateRange?.end;
    // If there's no date, set the current end date to an empty string
    if (!date || isNaN(date.getTime())) {
      this.currentEndDate = '';
      return;
    }
    const newEndDate = new DatePipe(navigator.language).transform(date, this.format);
    this.spaceForEndDate = this.currentEndDate === newEndDate ? this.spaceForEndDate === ' ' ? '' : ' ' : '';
    this.currentEndDate = newEndDate;
  }
  handleSelectedDateRangeNotSet(date) {
    if (this.minDate && this.maxDate && (new Date(date) < this.minDate || new Date(date) > this.maxDate)) {
      this.setErrorStateWhenDateHasError(this.outOfRange, "startDate" /* DATE_TYPE.START */);
      this.selectedDateRange = new DateRange(null, null);
    } else if (!this.isDisabled(date, "startDate" /* DATE_TYPE.START */)) {
      this.selectedDateRange = new DateRange(new Date(date), null);
      this.disabledSelectedDateRange.startDate = null;
    } else {
      this.selectedDateRange = new DateRange(null, null);
      this.disabledSelectedDateRange.startDate = new Date(date);
    }
    this.updateStartDate();
  }
  handleSelectedDateRangeSet(date) {
    const selected = this.getDateToValidate(date.toString());
    if (this.selectedDateRange) {
      const endDate = this.getEndDateToValidate();
      if (endDate && !isNaN(endDate.getTime()) && selected > endDate) {
        this.setErrorStateWhenDateHasError(this.notValidDateRange, "startDate" /* DATE_TYPE.START */);
        this.notAvailableSelectedDateRange.startDate = selected;
        this.disabledSelectedDateRange.startDate = null;
        this.selectedDateRange = new DateRange(selected, this.selectedDateRange.end);
        this._controlValueAccessorChangeFn(this.selectedDateRange);
      } else if (this.minDate && selected < this.minDate || this.maxDate && this.setStartOfDay(selected) > this.maxDate) {
        this.setErrorStateWhenDateHasError(this.outOfRange, "startDate" /* DATE_TYPE.START */);
        this.notAvailableSelectedDateRange.startDate = selected;
        this.disabledSelectedDateRange.startDate = null;
      } else if (!this.isDisabled(selected, "startDate" /* DATE_TYPE.START */)) {
        this.handleStartDateWhenNotDisabled(selected);
        this.handleEndDateWhenNotDisabled(selected);
        this.updateSelectedDateRange(selected);
      }
      this.updateStartDate();
    }
  }
  handleStartDateWhenNotDisabled(selected) {
    this.notAvailableSelectedDateRange.startDate = null;
    this.setErrorStateWhenDateHasNoError(this.notValidDateRange, "startDate" /* DATE_TYPE.START */);
    this.setErrorStateWhenDateHasNoError(this.outOfRange, "startDate" /* DATE_TYPE.START */);
  }
  handleEndDateWhenNotDisabled(selected) {
    const endDate = this.getEndDateToValidate();
    this.isDisabled(endDate, "endDate" /* DATE_TYPE.END */);
    if (this.lastUpdatedEndDate && this.isValidDate(this.lastUpdatedEndDate, "endDate" /* DATE_TYPE.END */)) {
      if (selected <= endDate) {
        this.setErrorStateWhenDateHasNoError(this.notValidDateRange, "endDate" /* DATE_TYPE.END */);
      }
    }
    if (!(this.minDate && endDate < this.minDate) && !(this.maxDate && endDate > this.maxDate)) {
      this.notAvailableSelectedDateRange.endDate = null;
      this.setErrorStateWhenDateHasNoError(this.outOfRange, "endDate" /* DATE_TYPE.END */);
    }
  }
  updateSelectedDateRange(selected) {
    this.selectedDateRange = new DateRange(selected, this.selectedDateRange.end);
    this._controlValueAccessorChangeFn(this.selectedDateRange);
  }
  handleEmptyStartDate() {
    Object.assign(this.errorMessages.currentErrorMsg, this.errorMessages.prevErrorMsg);
    this.setErrorMessagesStateByKey("prevErrorMsg" /* MESSAGE_STATE.PREV_ERROR */, null, null);
    this.invalidSelectedDateRange["startDate" /* DATE_TYPE.START */] = null;
    if (this.selectedDateRange && this.selectedDateRange.end) {
      this.selectedDateRange = new DateRange(null, this.selectedDateRange.end);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
    } else {
      this.selectedDateRange = new DateRange(null, null);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
    }
    this.updateStartDate();
  }
  handleEmptyEndDate() {
    Object.assign(this.errorMessages.currentErrorMsg, this.errorMessages.prevErrorMsg);
    this.setErrorMessagesStateByKey("prevErrorMsg" /* MESSAGE_STATE.PREV_ERROR */, null, null);
    this.invalidSelectedDateRange["endDate" /* DATE_TYPE.END */] = null;
    if (this.selectedDateRange && this.selectedDateRange.start) {
      this.selectedDateRange = new DateRange(this.selectedDateRange.start, null);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
    } else {
      this.selectedDateRange = new DateRange(null, null);
      this._controlValueAccessorChangeFn(this.selectedDateRange);
    }
    this.updateEndDate();
  }
  handleSelectedDateRangeEndSet(date) {
    const selected = this.getDateToValidate(date.toString());
    if (this.selectedDateRange) {
      const startDate = this.getStartDateToValidate();
      if (startDate && !isNaN(startDate.getTime()) && selected < startDate) {
        this.setErrorStateWhenDateHasError(this.notValidDateRange, "endDate" /* DATE_TYPE.END */);
        this.notAvailableSelectedDateRange.endDate = this.setEndOfDay(selected);
        this.disabledSelectedDateRange.endDate = null;
        const endDate = this.selectedDateRange.end || null;
        this.selectedDateRange = new DateRange(this.selectedDateRange.start, endDate);
        this._controlValueAccessorChangeFn(this.selectedDateRange);
      } else if (this.minDate && selected < this.minDate || this.maxDate && this.setStartOfDay(selected) > this.maxDate) {
        this.setErrorStateWhenDateHasError(this.outOfRange, "endDate" /* DATE_TYPE.END */);
        this.notAvailableSelectedDateRange.endDate = this.setEndOfDay(selected);
        this.disabledSelectedDateRange.endDate = null;
      } else if (!this.isDisabled(selected, "endDate" /* DATE_TYPE.END */)) {
        this.handleEndDateWhenNotDisabledForEndSet(selected);
        this.handleStartDateWhenNotDisabledForEndSet(selected);
        this.updateSelectedDateRangeForEndSet(selected);
      }
      this.updateEndDate();
    }
  }
  handleEndDateWhenNotDisabledForEndSet(selected) {
    this.notAvailableSelectedDateRange.endDate = null;
    this.setErrorStateWhenDateHasNoError(this.notValidDateRange, "endDate" /* DATE_TYPE.END */);
    this.setErrorStateWhenDateHasNoError(this.outOfRange, "endDate" /* DATE_TYPE.END */);
  }
  handleStartDateWhenNotDisabledForEndSet(selected) {
    const startDate = this.getStartDateToValidate();
    this.isDisabled(startDate, "startDate" /* DATE_TYPE.START */);
    if (this.lastUpdatedStartDate && this.isValidDate(this.lastUpdatedStartDate, "startDate" /* DATE_TYPE.START */)) {
      if (selected >= startDate) {
        this.setErrorStateWhenDateHasNoError(this.notValidDateRange, "startDate" /* DATE_TYPE.START */);
      }
    }
    if (!(this.minDate && startDate < this.minDate) && !(this.maxDate && startDate > this.maxDate)) {
      this.notAvailableSelectedDateRange.startDate = null;
      this.setErrorStateWhenDateHasNoError(this.outOfRange, "startDate" /* DATE_TYPE.START */);
    }
  }
  updateSelectedDateRangeForEndSet(selected) {
    this.selectedDateRange = new DateRange(this.selectedDateRange.start, this.setEndOfDay(selected));
    this._controlValueAccessorChangeFn(this.selectedDateRange);
  }
  handleSelectedDateRangeEndNotSet(date) {
    if (this.minDate && this.maxDate && (new Date(date) < this.minDate || new Date(date) > this.maxDate)) {
      this.setErrorStateWhenDateHasError(this.outOfRange, "endDate" /* DATE_TYPE.END */);
      this.selectedDateRange = new DateRange(null, null);
    } else if (!this.isDisabled(date, "endDate" /* DATE_TYPE.END */)) {
      this.selectedDateRange = new DateRange(null, this.setEndOfDay(new Date(date)));
      this.disabledSelectedDateRange.endDate = null;
    } else {
      this.selectedDateRange = new DateRange(null, null);
      this.disabledSelectedDateRange.endDate = this.setEndOfDay(new Date(date));
    }
    this.updateEndDate();
  }
  setErrorStateWhenDateHasNoError(errorMsg, dateType) {
    const {
      prevErrorMsg,
      currentErrorMsg
    } = this.errorMessages;
    const isPrevErrorMatch = prevErrorMsg.dateType === dateType && prevErrorMsg.errorMsg === errorMsg;
    const isCurrentErrorMatch = currentErrorMsg.errorMsg === errorMsg && currentErrorMsg.dateType === dateType;
    if (isPrevErrorMatch || isCurrentErrorMatch) {
      if (isCurrentErrorMatch) {
        this.errorMessages.currentErrorMsg = {
          ...prevErrorMsg
        };
      }
      this.setErrorMessagesStateByKey("prevErrorMsg" /* MESSAGE_STATE.PREV_ERROR */, null, null);
    }
  }
  setErrorStateWhenDateHasError(errorMsg, dateType) {
    const {
      prevErrorMsg,
      currentErrorMsg
    } = this.errorMessages;
    const isPrevErrorMatch = prevErrorMsg.dateType === dateType && prevErrorMsg.errorMsg === errorMsg;
    const isCurrentErrorMatch = currentErrorMsg.errorMsg === errorMsg && currentErrorMsg.dateType === dateType;
    if (isPrevErrorMatch || isCurrentErrorMatch) {
      if (!currentErrorMsg.errorMsg) {
        this.errorMessages.currentErrorMsg = {
          ...prevErrorMsg
        };
        this.setErrorMessagesStateByKey("prevErrorMsg" /* MESSAGE_STATE.PREV_ERROR */, null, null);
      }
      return;
    }
    const isCurrentErrorMsgMatch = currentErrorMsg.errorMsg === errorMsg;
    if (isCurrentErrorMsgMatch) {
      if (currentErrorMsg.dateType !== dateType) {
        this.errorMessages.prevErrorMsg = {
          ...currentErrorMsg
        };
        this.setErrorMessagesStateByKey("currentErrorMsg" /* MESSAGE_STATE.CURRENT_ERROR */, errorMsg, dateType);
      }
    } else {
      if (currentErrorMsg.dateType !== dateType) {
        this.errorMessages.prevErrorMsg = {
          ...currentErrorMsg
        };
      }
      this.setErrorMessagesStateByKey("currentErrorMsg" /* MESSAGE_STATE.CURRENT_ERROR */, errorMsg, dateType);
    }
  }
  setErrorMessagesStateByKey(errorKey, errorMsg, dateType) {
    this.errorMessages[errorKey].errorMsg = errorMsg;
    this.errorMessages[errorKey].dateType = dateType;
  }
  isCurrentErrorMessageAlreadySet(errorMsg, dateType) {
    return this.errorMessages.currentErrorMsg.errorMsg === errorMsg && this.errorMessages.currentErrorMsg.dateType === dateType;
  }
  isDisabled(date, dateType) {
    if (this.daysDisabled.includes(this.getDateToValidate(date.toString()).getDay())) {
      this.setErrorStateWhenDateHasError(this.disabledDate, dateType);
      this.disabledSelectedDateRange[dateType] = date;
      return true;
    } else {
      this.setErrorStateWhenDateHasNoError(this.disabledDate, dateType);
      this.disabledSelectedDateRange[dateType] = null;
      return false;
    }
  }
  checkInvalidDate() {
    if (this.selectedDateRange && !this.selectedDateRange.start && !this.invalidSelectedDateRange.startDate && !this.startDate) {
      this.setErrorStateWhenDateHasError(this.selectStartDateError, "startDate" /* DATE_TYPE.START */);
      return;
    } else if (this.isCurrentErrorMessageAlreadySet(this.selectStartDateError, "startDate" /* DATE_TYPE.START */)) {
      this.setErrorStateWhenDateHasNoError(this.selectStartDateError, "startDate" /* DATE_TYPE.START */);
    }
    if (this.selectedDateRange && !this.selectedDateRange.end && !this.invalidSelectedDateRange.endDate && !this.endDate) {
      this.setErrorStateWhenDateHasError(this.selectEndDateError, "endDate" /* DATE_TYPE.END */);
    } else if (this.isCurrentErrorMessageAlreadySet(this.selectEndDateError, "endDate" /* DATE_TYPE.END */)) {
      this.setErrorStateWhenDateHasNoError(this.selectEndDateError, "endDate" /* DATE_TYPE.END */);
    }
  }
  disabledDateSelectedFn() {
    this.isDisabled(this.getStartDateToValidate(), "startDate" /* DATE_TYPE.START */);
    this.isDisabled(this.getEndDateToValidate(), "endDate" /* DATE_TYPE.END */);
  }
  timeRangeCheck(value) {
    if (value) {
      this.setErrorStateWhenDateHasError(this.invalidDateTime, "endDate" /* DATE_TYPE.END */);
    } else {
      this.setErrorStateWhenDateHasNoError(this.invalidDateTime, "endDate" /* DATE_TYPE.END */);
    }
  }
  dateSelection(dateRange) {
    if (this.notAvailableSelectedDateRange.startDate && dateRange.start) {
      this.handleSelectedDateRangeSet(dateRange.start);
    } else if (this.notAvailableSelectedDateRange.endDate && dateRange.end) {
      this.handleSelectedDateRangeEndSet(dateRange.end);
    } else {
      this.selectedDateRange = dateRange;
      this._controlValueAccessorChangeFn(dateRange);
      this.handleEndDateForDateSelection();
      this.handleStartDateForDateSelection();
      this.updateSelectedDateRangeForDateSelection(dateRange);
      this.lastUpdatedStartDate = dateRange.start?.toDateString() || null;
      this.lastUpdatedEndDate = dateRange.end?.toDateString() || null;
      this.updateStartDate();
      this.updateEndDate();
    }
  }
  handleEndDateForDateSelection() {
    if (this.selectedDateRange.end) {
      this.setErrorStateWhenDateHasNoError(this.selectEndDateError, "endDate" /* DATE_TYPE.END */);
      if (this.invalidSelectedDateRange["endDate" /* DATE_TYPE.END */]) {
        this.setErrorStateWhenDateHasNoError(this.invalidDate, "endDate" /* DATE_TYPE.END */);
        this.invalidSelectedDateRange["endDate" /* DATE_TYPE.END */] = null;
      }
      if (this.disabledSelectedDateRange.endDate) {
        this.setErrorStateWhenDateHasNoError(this.disabledDate, "endDate" /* DATE_TYPE.END */);
        this.disabledSelectedDateRange.endDate = null;
      }
    } else {
      this.setErrorStateWhenDateHasNoError(this.invalidDate, "endDate" /* DATE_TYPE.END */);
      this.setErrorStateWhenDateHasNoError(this.disabledDate, "endDate" /* DATE_TYPE.END */);
      this.invalidSelectedDateRange["endDate" /* DATE_TYPE.END */] = null;
      this.disabledSelectedDateRange["endDate" /* DATE_TYPE.END */] = null;
    }
  }
  handleStartDateForDateSelection() {
    if (this.selectedDateRange.start) {
      this.setErrorStateWhenDateHasNoError(this.selectStartDateError, "startDate" /* DATE_TYPE.START */);
      if (this.invalidSelectedDateRange["startDate" /* DATE_TYPE.START */]) {
        this.setErrorStateWhenDateHasNoError(this.invalidDate, "startDate" /* DATE_TYPE.START */);
        this.invalidSelectedDateRange["startDate" /* DATE_TYPE.START */] = null;
      }
      if (this.disabledSelectedDateRange.startDate) {
        this.setErrorStateWhenDateHasNoError(this.disabledDate, "startDate" /* DATE_TYPE.START */);
        this.disabledSelectedDateRange.startDate = null;
      }
    } else {
      this.setErrorStateWhenDateHasNoError(this.invalidDate, "startDate" /* DATE_TYPE.START */);
      this.setErrorStateWhenDateHasNoError(this.disabledDate, "startDate" /* DATE_TYPE.START */);
      this.invalidSelectedDateRange["startDate" /* DATE_TYPE.START */] = null;
      this.disabledSelectedDateRange["startDate" /* DATE_TYPE.START */] = null;
    }
  }
  updateSelectedDateRangeForDateSelection(dateRange) {
    if (dateRange.start && dateRange.end && dateRange.start > dateRange.end) {
      this.setErrorStateWhenDateHasError(this.notValidDateRange, "endDate" /* DATE_TYPE.END */);
      this.notAvailableSelectedDateRange.endDate = this.setEndOfDay(new Date(dateRange.end));
    } else {
      this.setErrorStateWhenDateHasNoError(this.notValidDateRange, "endDate" /* DATE_TYPE.END */);
      this.notAvailableSelectedDateRange.endDate = null;
    }
  }
  toggleOverlay(value) {
    this.overlayOpen = value;
    if (this.selectedDateRange && this.selectedDateRange.start && !value) {
      if (!this.selectedDateRange.end) {
        this.setErrorStateWhenDateHasError(this.selectEndDateError, "endDate" /* DATE_TYPE.END */);
        return;
      }
    }
  }
  previousDateRange() {
    if (this.maxDate && this.minDate && this.selectedDateRange && this.selectedDateRange.end && this.selectedDateRange.start && this.selectedDateRange.start > this.minDate || this.selectedDateRange && this.selectedDateRange.end && this.selectedDateRange.start) {
      const firstDate = this.changeToPreviousDate(this.selectedDateRange.start, "startDate" /* DATE_TYPE.START */);
      const lastDate = this.changeToPreviousDate(this.selectedDateRange.end, "endDate" /* DATE_TYPE.END */);
      if (firstDate && lastDate) {
        this.selectedDateRange = new DateRange(firstDate, lastDate);
        this.disabledSelectedDateRange = {
          startDate: null,
          endDate: null
        };
        this.updateEndDate();
        this.updateStartDate();
        this._controlValueAccessorChangeFn(this.selectedDateRange);
        this.setErrorMessagesStateByKey("currentErrorMsg" /* MESSAGE_STATE.CURRENT_ERROR */, null, null);
        this.setErrorMessagesStateByKey("prevErrorMsg" /* MESSAGE_STATE.PREV_ERROR */, null, null);
      } else {
        if (!firstDate) {
          this.setErrorStateWhenDateHasError(this.disabledDate, "startDate" /* DATE_TYPE.START */);
        }
        if (!lastDate) {
          this.setErrorStateWhenDateHasError(this.disabledDate, "endDate" /* DATE_TYPE.END */);
        }
      }
    }
  }
  changeToPreviousDate(date, dateType) {
    let previousDay;
    if (this.type === 'range-selection') {
      previousDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    } else {
      previousDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
    }
    previousDay.setHours(date.getHours());
    previousDay.setMinutes(date.getMinutes());
    previousDay.setSeconds(date.getSeconds());
    if (!this.isDisabled(previousDay, dateType)) {
      return previousDay;
    } else {
      return;
    }
  }
  changeToNextDate(date, dateType) {
    let nextDay;
    if (this.type === 'range-selection') {
      nextDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    } else {
      nextDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7);
    }
    nextDay.setHours(date.getHours());
    nextDay.setMinutes(date.getMinutes());
    nextDay.setSeconds(date.getSeconds());
    if (!this.isDisabled(nextDay, dateType)) {
      return nextDay;
    } else {
      return;
    }
  }
  nextDateRange() {
    if (this.maxDate && this.minDate && this.selectedDateRange && this.selectedDateRange.end && this.selectedDateRange.start && this.selectedDateRange.end < this.maxDate || this.selectedDateRange && this.selectedDateRange.end && this.selectedDateRange.start) {
      const firstDate = this.changeToNextDate(this.selectedDateRange.start, "startDate" /* DATE_TYPE.START */);
      const lastDate = this.changeToNextDate(this.selectedDateRange.end, "endDate" /* DATE_TYPE.END */);
      if (firstDate && lastDate) {
        this.selectedDateRange = new DateRange(firstDate, lastDate);
        this.disabledSelectedDateRange = {
          startDate: null,
          endDate: null
        };
        this.updateEndDate();
        this.updateStartDate();
        this._controlValueAccessorChangeFn(this.selectedDateRange);
        this.setErrorMessagesStateByKey("currentErrorMsg" /* MESSAGE_STATE.CURRENT_ERROR */, null, null);
        this.setErrorMessagesStateByKey("prevErrorMsg" /* MESSAGE_STATE.PREV_ERROR */, null, null);
      } else {
        if (!firstDate) {
          this.setErrorStateWhenDateHasError(this.disabledDate, "startDate" /* DATE_TYPE.START */);
        }
        if (!lastDate) {
          this.setErrorStateWhenDateHasError(this.disabledDate, "endDate" /* DATE_TYPE.END */);
        }
      }
    }
  }
  changetheSelectedDate(value) {
    this.cdr.detectChanges();
    const endDate = new Date();
    const startDate = new Date(endDate);
    if (!this.isDisabled(endDate, "endDate" /* DATE_TYPE.END */)) {
      startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - value);
      if (!this.isDisabled(startDate, "startDate" /* DATE_TYPE.START */)) {
        this.updateDateRangeValues(this.setStartOfDay(startDate), this.setEndOfDay(endDate));
      }
    }
  }
  changeMonth(value) {
    const endDate = new Date();
    const startDate = new Date(endDate);
    if (!this.isDisabled(endDate, "endDate" /* DATE_TYPE.END */) && value > 0) {
      //select the all prev month
      startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth() - value, 1);
      endDate?.setFullYear(startDate.getFullYear(), startDate.getMonth() + value, 0);
      if (!this.isDisabled(startDate, "startDate" /* DATE_TYPE.START */)) {
        this.updateDateRangeValues(this.setStartOfDay(startDate), this.setEndOfDay(endDate));
      }
    } else {
      //only current days on month should be selected
      startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth(), 1);
      this.updateDateRangeValues(this.setStartOfDay(startDate), this.setEndOfDay(endDate));
    }
  }
  updateDateRangeValues(startDate, endDate) {
    this.selectedDateRange = new DateRange(startDate, endDate);
    this.lastUpdatedStartDate = this.selectedDateRange.start?.toDateString() || null;
    this.lastUpdatedEndDate = this.selectedDateRange.end?.toDateString() || null;
    this.updateEndDate();
    this.updateStartDate();
    this._controlValueAccessorChangeFn(this.selectedDateRange);
  }
  selectNumRange(value) {
    const endDate = new Date();
    const startDate = new Date(endDate);
    if (!this.isDisabled(endDate, "endDate" /* DATE_TYPE.END */)) {
      startDate?.setFullYear(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - value);
      if (!this.isDisabled(startDate, "startDate" /* DATE_TYPE.START */)) {
        this.updateDateRangeValues(this.setStartOfDay(startDate), this.setEndOfDay(endDate));
      }
    }
  }
  static {
    this.ɵfac = function DateRangePickerComponent_Factory(t) {
      return new (t || DateRangePickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateRangePickerComponent,
      selectors: [["sol-date-range-picker"]],
      viewQuery: function DateRangePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(DateRangeWrapperComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarEl = _t.first);
        }
      },
      inputs: {
        format: "format",
        displayleftPanel: "displayleftPanel",
        minDate: "minDate",
        maxDate: "maxDate",
        daysDisabled: "daysDisabled",
        specialDates: "specialDates",
        disabled: "disabled",
        readonly: "readonly",
        startingDay: "startingDay",
        type: "type",
        showActionArrows: "showActionArrows",
        arrowPosition: "arrowPosition"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateRangePickerComponent),
        multi: true
      }])],
      decls: 39,
      vars: 56,
      consts: [[1, "sol-date-range-container"], [1, "date-range-label"], [1, "label-class"], [1, "date-range-subcontainer"], ["class", "action-button-container", 4, "ngIf"], [1, "input-container"], ["inputText", ""], [1, "input-subcontainer"], [1, "sol-date-range-input", 3, "disabled", "readonly", "placeholder", "ngModel", "ngModelOptions", "ngModelChange", "blur"], ["startInput", ""], ["endInput", ""], ["width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "calendar-icon", 3, "solDateRangeOverlay", "solTextInput", "tabindex", "haveBackDrop", "overlayChanged"], ["d", "M17.5 2H15.5V0H13.5V2H6.5V0H4.5V2H2.5C1.39562 2 0.5 2.89563 0.5 4V18C0.5 19.1044 1.39562 20 2.5 20H17.5C18.6044 20 19.5 19.1044 19.5 18V4C19.5 2.89563 18.6044 2 17.5 2ZM17.5 18H2.5V8H17.5V18ZM17.5 6H2.5V4H4.5V5H6.5V4H13.5V5H15.5V4H17.5V6Z", "fill", "black"], ["d", "M10.5 9H12.5V11H10.5V9Z", "fill", "black"], ["d", "M10.5 12H12.5V14H10.5V12Z", "fill", "black"], ["d", "M10.5 15H12.5V17H10.5V15Z", "fill", "black"], ["d", "M7.5 9H9.5V11H7.5V9Z", "fill", "black"], ["d", "M7.5 12H9.5V14H7.5V12Z", "fill", "black"], ["d", "M7.5 15H9.5V17H7.5V15Z", "fill", "black"], ["d", "M4.5 12H6.5V14H4.5V12Z", "fill", "black"], ["d", "M4.5 15H6.5V17H4.5V15Z", "fill", "black"], ["d", "M13.5 9H15.5V11H13.5V9Z", "fill", "black"], ["d", "M13.5 12H15.5V14H13.5V12Z", "fill", "black"], [1, "error-message"], [3, "ngModel", "displayleftPanel", "min", "max", "overlayState", "showTime", "daysDisabled", "specialDates", "startingDay", "type", "dateSelected", "ngModelChange", "listSelected", "selectedMonth", "numericSelctorOutput", "disabledDateSelected", "timeRangeEvent"], ["openCalender", ""], ["previous", ""], ["next", ""], [1, "action-button-container"], [3, "variant", "size", "iconPositionedFront", "disabled", "ariaLabel", "onClick"], ["width", "6.4", "height", "12.8", "viewBox", "0 0 8 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0.981181 6.20399L6.11326 0.791051C6.35477 0.536325 6.77741 0.536325 7.01892 0.791051C7.26043 1.04578 7.26043 1.49155 7.01892 1.74627L2.18873 6.8408L7.01892 12.2537C7.26043 12.5085 7.26043 12.9542 7.01892 13.209C6.77741 13.4637 6.35477 13.4637 6.11326 13.209L0.981181 7.47762C0.800049 7.28657 0.800049 7.09553 0.800049 6.90448C0.800049 6.58608 0.860426 6.33135 0.981181 6.20399Z", "fill", "currentColor"], ["d", "M7.01892 6.20399L1.88684 0.791051C1.64533 0.536325 1.22269 0.536325 0.981181 0.791051C0.739671 1.04578 0.739671 1.49155 0.981181 1.74627L5.81137 6.8408L0.981181 12.2537C0.739671 12.5085 0.739671 12.9542 0.981181 13.209C1.22269 13.4637 1.64533 13.4637 1.88684 13.209L7.01892 7.47762C7.20005 7.28657 7.20005 7.09553 7.20005 6.90448C7.20005 6.58608 7.13967 6.33135 7.01892 6.20399Z", "fill", "currentColor"]],
      template: function DateRangePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 3);
          i0.ɵɵtemplate(5, DateRangePickerComponent_div_5_Template, 5, 14, "div", 4);
          i0.ɵɵelementStart(6, "div")(7, "div", 5, 6)(9, "div", 7)(10, "input", 8, 9);
          i0.ɵɵtwoWayListener("ngModelChange", function DateRangePickerComponent_Template_input_ngModelChange_10_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.startDate, $event) || (ctx.startDate = $event);
            return $event;
          });
          i0.ɵɵlistener("blur", function DateRangePickerComponent_Template_input_blur_10_listener() {
            return ctx.checkInvalidDate();
          });
          i0.ɵɵpipe(12, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(13, " - ");
          i0.ɵɵelementStart(14, "input", 8, 10);
          i0.ɵɵtwoWayListener("ngModelChange", function DateRangePickerComponent_Template_input_ngModelChange_14_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.endDate, $event) || (ctx.endDate = $event);
            return $event;
          });
          i0.ɵɵlistener("blur", function DateRangePickerComponent_Template_input_blur_14_listener() {
            return ctx.checkInvalidDate();
          });
          i0.ɵɵpipe(16, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(17, "svg", 11);
          i0.ɵɵlistener("overlayChanged", function DateRangePickerComponent_Template__svg_svg_overlayChanged_17_listener($event) {
            return ctx.toggleOverlay($event);
          });
          i0.ɵɵelement(18, "path", 12)(19, "path", 13)(20, "path", 14)(21, "path", 15)(22, "path", 16)(23, "path", 17)(24, "path", 18)(25, "path", 19)(26, "path", 20)(27, "path", 21)(28, "path", 22);
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(29, "div")(30, "span", 23);
          i0.ɵɵtext(31);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(32, DateRangePickerComponent_div_32_Template, 5, 14, "div", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(33, "sol-date-range-wrapper", 24, 25);
          i0.ɵɵlistener("dateSelected", function DateRangePickerComponent_Template_sol_date_range_wrapper_dateSelected_33_listener($event) {
            return ctx.dateSelection($event);
          });
          i0.ɵɵtwoWayListener("ngModelChange", function DateRangePickerComponent_Template_sol_date_range_wrapper_ngModelChange_33_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedDateRange, $event) || (ctx.selectedDateRange = $event);
            return $event;
          });
          i0.ɵɵlistener("listSelected", function DateRangePickerComponent_Template_sol_date_range_wrapper_listSelected_33_listener($event) {
            return ctx.changetheSelectedDate($event);
          })("selectedMonth", function DateRangePickerComponent_Template_sol_date_range_wrapper_selectedMonth_33_listener($event) {
            return ctx.changeMonth($event);
          })("numericSelctorOutput", function DateRangePickerComponent_Template_sol_date_range_wrapper_numericSelctorOutput_33_listener($event) {
            return ctx.selectNumRange($event);
          })("disabledDateSelected", function DateRangePickerComponent_Template_sol_date_range_wrapper_disabledDateSelected_33_listener() {
            return ctx.disabledDateSelectedFn();
          })("timeRangeEvent", function DateRangePickerComponent_Template_sol_date_range_wrapper_timeRangeEvent_33_listener($event) {
            return ctx.timeRangeCheck($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(35, DateRangePickerComponent_ng_template_35_Template, 2, 0, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor)(37, DateRangePickerComponent_ng_template_37_Template, 2, 0, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const _r1 = i0.ɵɵreference(8);
          const _r5 = i0.ɵɵreference(34);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("with-time-picker", ctx.showTime)("label-disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("label-disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.dateRangeLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.showActionArrows && ctx.arrowPosition === "left");
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("disabled", ctx.disabled)("with-time-width", ctx.showTime)("read-only", ctx.readonly || ctx.type === "week-selection" || ctx.overlayOpen)("error-border", ctx.errorMessages.currentErrorMsg.errorMsg);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("width-time", ctx.showTime);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("with-time", ctx.showTime);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 50, "startDatePlaceholder"));
          i0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly || ctx.type === "week-selection" || ctx.overlayOpen);
          i0.ɵɵtwoWayProperty("ngModel", ctx.startDate);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(54, _c3));
          i0.ɵɵadvance(4);
          i0.ɵɵclassProp("with-time", ctx.showTime);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(16, 52, "endDatePlaceholder"));
          i0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly || ctx.type === "week-selection" || ctx.overlayOpen);
          i0.ɵɵtwoWayProperty("ngModel", ctx.endDate);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(55, _c3));
          i0.ɵɵadvance(3);
          i0.ɵɵclassProp("svg-disabled", ctx.disabled || ctx.readonly);
          i0.ɵɵproperty("solDateRangeOverlay", _r5)("solTextInput", _r1)("tabindex", ctx.disabled || ctx.readonly ? -1 : 0)("haveBackDrop", ctx.showTime);
          i0.ɵɵadvance(14);
          i0.ɵɵtextInterpolate1(" ", ctx.errorMessages.currentErrorMsg.errorMsg, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showActionArrows && ctx.arrowPosition === "right");
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedDateRange);
          i0.ɵɵproperty("displayleftPanel", ctx.displayleftPanel)("min", ctx.minDate)("max", ctx.maxDate)("overlayState", ctx.overlayOpen)("showTime", ctx.showTime)("daysDisabled", ctx.daysDisabled)("specialDates", ctx.specialDates)("startingDay", ctx.startingDay)("type", ctx.type);
        }
      },
      dependencies: [i3.NgIf, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgModel, i7.ButtonComponent, DateRangeWrapperComponent, DateRangePickerDirective, i1$1.TranslationPipe],
      styles: [_c4],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangePickerComponent, [{
    type: Component,
    args: [{
      selector: 'sol-date-range-picker',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DateRangePickerComponent),
        multi: true
      }],
      template: "<div class=\"sol-date-range-container\">\n  <div class=\"date-range-label\" [class.with-time-picker]=\"showTime\" [class.label-disabled]=\"disabled\">\n    <label class=\"label-class\" [class.label-disabled]=\"disabled\">{{ dateRangeLabel }}</label>\n  </div>\n  <div class=\"date-range-subcontainer\">\n    <div class=\"action-button-container\" *ngIf=\"showActionArrows && arrowPosition === 'left'\">\n      <sol-button\n        [variant]=\"'basic'\"\n        [size]=\"'large'\"\n        [iconPositionedFront]=\"previous\"\n        [disabled]=\"\n          disabled ||\n          overlayOpen ||\n          (selectedDateRange && selectedDateRange.start && minDate && selectedDateRange.start <= minDate) ||\n          !selectedDateRange ||\n          !selectedDateRange.start ||\n          !selectedDateRange.end ||\n          !!notAvailableSelectedDateRange.startDate ||\n          !!notAvailableSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.startDate ||\n          (!startDate && !endDate)\n        \"\n        (onClick)=\"previousDateRange()\"\n        ariaLabel=\"{{ 'previousIcon' | translate }}\"\n      ></sol-button>\n      <sol-button\n        [variant]=\"'basic'\"\n        [size]=\"'large'\"\n        [iconPositionedFront]=\"next\"\n        [disabled]=\"\n          disabled ||\n          overlayOpen ||\n          (selectedDateRange && selectedDateRange.end && maxDate && selectedDateRange.end >= maxDate) ||\n          !selectedDateRange ||\n          !selectedDateRange.start ||\n          !selectedDateRange.end ||\n          !!notAvailableSelectedDateRange.startDate ||\n          !!notAvailableSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.startDate ||\n          (!startDate && !endDate)\n        \"\n        (onClick)=\"nextDateRange()\"\n        ariaLabel=\"{{ 'nextIcon' | translate }}\"\n      ></sol-button>\n    </div>\n    <div>\n      <div\n        class=\"input-container\"\n        [class.disabled]=\"disabled\"\n        [class.with-time-width]=\"showTime\"\n        [class.read-only]=\"readonly || type === 'week-selection' || overlayOpen\"\n        [class.error-border]=\"errorMessages.currentErrorMsg.errorMsg\"\n        #inputText\n      >\n        <div class=\"input-subcontainer\" [class.width-time]=\"showTime\">\n          <input\n            #startInput\n            class=\"sol-date-range-input\"\n            [class.with-time]=\"showTime\"\n            [disabled]=\"disabled\"\n            [readonly]=\"readonly || type === 'week-selection' || overlayOpen\"\n            placeholder=\"{{ 'startDatePlaceholder' | translate }}\"\n            [(ngModel)]=\"startDate\"\n            (blur)=\"checkInvalidDate()\"\n            [ngModelOptions]=\"{ updateOn: 'blur' }\"\n          />\n          -\n          <input\n            #endInput\n            class=\"sol-date-range-input\"\n            [class.with-time]=\"showTime\"\n            [disabled]=\"disabled\"\n            [readonly]=\"readonly || type === 'week-selection' || overlayOpen\"\n            placeholder=\"{{ 'endDatePlaceholder' | translate }}\"\n            [(ngModel)]=\"endDate\"\n            (blur)=\"checkInvalidDate()\"\n            [ngModelOptions]=\"{ updateOn: 'blur' }\"\n          />\n        </div>\n        <svg\n          [solDateRangeOverlay]=\"openCalender\"\n          [solTextInput]=\"inputText\"\n          (overlayChanged)=\"toggleOverlay($event)\"\n          [tabindex]=\"disabled || readonly ? -1 : 0\"\n          [class.svg-disabled]=\"disabled || readonly\"\n          [haveBackDrop]=\"showTime\"\n          class=\"calendar-icon\"\n          width=\"20\"\n          height=\"20\"\n          viewBox=\"0 0 20 20\"\n          fill=\"none\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n        >\n          <path\n            d=\"M17.5 2H15.5V0H13.5V2H6.5V0H4.5V2H2.5C1.39562 2 0.5 2.89563 0.5 4V18C0.5 19.1044 1.39562 20 2.5 20H17.5C18.6044 20 19.5 19.1044 19.5 18V4C19.5 2.89563 18.6044 2 17.5 2ZM17.5 18H2.5V8H17.5V18ZM17.5 6H2.5V4H4.5V5H6.5V4H13.5V5H15.5V4H17.5V6Z\"\n            fill=\"black\"\n          />\n          <path d=\"M10.5 9H12.5V11H10.5V9Z\" fill=\"black\" />\n          <path d=\"M10.5 12H12.5V14H10.5V12Z\" fill=\"black\" />\n          <path d=\"M10.5 15H12.5V17H10.5V15Z\" fill=\"black\" />\n          <path d=\"M7.5 9H9.5V11H7.5V9Z\" fill=\"black\" />\n          <path d=\"M7.5 12H9.5V14H7.5V12Z\" fill=\"black\" />\n          <path d=\"M7.5 15H9.5V17H7.5V15Z\" fill=\"black\" />\n          <path d=\"M4.5 12H6.5V14H4.5V12Z\" fill=\"black\" />\n          <path d=\"M4.5 15H6.5V17H4.5V15Z\" fill=\"black\" />\n          <path d=\"M13.5 9H15.5V11H13.5V9Z\" fill=\"black\" />\n          <path d=\"M13.5 12H15.5V14H13.5V12Z\" fill=\"black\" />\n        </svg>\n      </div>\n      <div>\n        <span class=\"error-message\">\n          {{ errorMessages.currentErrorMsg.errorMsg }}\n        </span>\n      </div>\n    </div>\n    <div class=\"action-button-container\" *ngIf=\"showActionArrows && arrowPosition === 'right'\">\n      <sol-button\n        [variant]=\"'basic'\"\n        [size]=\"'large'\"\n        [iconPositionedFront]=\"previous\"\n        [disabled]=\"\n          disabled ||\n          overlayOpen ||\n          (selectedDateRange && selectedDateRange.start && minDate && selectedDateRange.start <= minDate) ||\n          !selectedDateRange ||\n          !selectedDateRange.start ||\n          !selectedDateRange.end ||\n          !!notAvailableSelectedDateRange.startDate ||\n          !!notAvailableSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.startDate ||\n          (!startDate && !endDate)\n        \"\n        (onClick)=\"previousDateRange()\"\n        ariaLabel=\"{{ 'previousIcon' | translate }}\"\n      ></sol-button>\n      <sol-button\n        [variant]=\"'basic'\"\n        [size]=\"'large'\"\n        [iconPositionedFront]=\"next\"\n        [disabled]=\"\n          disabled ||\n          overlayOpen ||\n          (selectedDateRange && selectedDateRange.end && maxDate && selectedDateRange.end >= maxDate) ||\n          !selectedDateRange ||\n          !selectedDateRange.start ||\n          !selectedDateRange.end ||\n          !!notAvailableSelectedDateRange.startDate ||\n          !!notAvailableSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.endDate ||\n          !!invalidSelectedDateRange.startDate ||\n          (!startDate && !endDate)\n        \"\n        (onClick)=\"nextDateRange()\"\n        ariaLabel=\"{{ 'nextIcon' | translate }}\"\n      ></sol-button>\n    </div>\n  </div>\n  <sol-date-range-wrapper\n    #openCalender\n    (dateSelected)=\"dateSelection($event)\"\n    [(ngModel)]=\"selectedDateRange\"\n    [displayleftPanel]=\"displayleftPanel\"\n    (listSelected)=\"changetheSelectedDate($event)\"\n    (selectedMonth)=\"changeMonth($event)\"\n    (numericSelctorOutput)=\"selectNumRange($event)\"\n    (disabledDateSelected)=\"disabledDateSelectedFn()\"\n    (timeRangeEvent)=\"timeRangeCheck($event)\"\n    [min]=\"minDate\"\n    [max]=\"maxDate\"\n    [overlayState]=\"overlayOpen\"\n    [showTime]=\"showTime\"\n    [daysDisabled]=\"daysDisabled\"\n    [specialDates]=\"specialDates\"\n    [startingDay]=\"startingDay\"\n    [type]=\"type\"\n  ></sol-date-range-wrapper>\n  <ng-template #previous>\n    <svg width=\"6.4\" height=\"12.8\" viewBox=\"0 0 8 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M0.981181 6.20399L6.11326 0.791051C6.35477 0.536325 6.77741 0.536325 7.01892 0.791051C7.26043 1.04578 7.26043 1.49155 7.01892 1.74627L2.18873 6.8408L7.01892 12.2537C7.26043 12.5085 7.26043 12.9542 7.01892 13.209C6.77741 13.4637 6.35477 13.4637 6.11326 13.209L0.981181 7.47762C0.800049 7.28657 0.800049 7.09553 0.800049 6.90448C0.800049 6.58608 0.860426 6.33135 0.981181 6.20399Z\"\n        fill=\"currentColor\"\n      />\n    </svg>\n  </ng-template>\n  <ng-template #next>\n    <svg width=\"6.4\" height=\"12.8\" viewBox=\"0 0 8 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M7.01892 6.20399L1.88684 0.791051C1.64533 0.536325 1.22269 0.536325 0.981181 0.791051C0.739671 1.04578 0.739671 1.49155 0.981181 1.74627L5.81137 6.8408L0.981181 12.2537C0.739671 12.5085 0.739671 12.9542 0.981181 13.209C1.22269 13.4637 1.64533 13.4637 1.88684 13.209L7.01892 7.47762C7.20005 7.28657 7.20005 7.09553 7.20005 6.90448C7.20005 6.58608 7.13967 6.33135 7.01892 6.20399Z\"\n        fill=\"currentColor\"\n      />\n    </svg>\n  </ng-template>\n</div>\n",
      styles: [".sol-date-range-container .date-range-label{width:19.0625rem}.sol-date-range-container .date-range-label.with-time-picker{width:31.875rem}.sol-date-range-container .date-range-label .label-class{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:1.021rem;letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:var(--outline-offset4)}.sol-date-range-container .date-range-label .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .date-range-subcontainer{display:flex;gap:var(--outline-offset4)}.sol-date-range-container .input-container{width:19.0625rem;display:inline-flex;align-items:center;background-color:#fff;gap:1.75rem;height:2.25rem;border:.0625rem;border-style:solid;border-radius:var(--outline-offset4);border-color:var(--color-globalstate-inactive-border)}.sol-date-range-container .input-container.with-time-width{width:31.875rem}.sol-date-range-container .input-container .input-subcontainer{display:flex;align-items:center;width:15.375rem;color:var(--color-interface-text700)}.sol-date-range-container .input-container .input-subcontainer.width-time{width:28.125rem}.sol-date-range-container .input-container:hover{border-color:var(--color-globalstate-hover-border)}.sol-date-range-container .input-container:focus-within{border-color:var(--color-globalstate-active-border)}.sol-date-range-container .input-container.error-border{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .input-container.error-border:active,.sol-date-range-container .input-container.error-border:focus{border-color:var(--color-button-destructive-hover)}.sol-date-range-container .disabled{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);pointer-events:none;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .disabled svg path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .calendar-icon{outline:none;cursor:pointer}.sol-date-range-container .calendar-icon:focus-visible{outline:.0625rem solid var(--color-globalstate-focus);outline-offset:.125rem}.sol-date-range-container .calendar-icon.svg-disabled{pointer-events:none}.sol-date-range-container .calendar-icon.svg-disabled path{fill:var(--color-globalstate-disabled-border)}.sol-date-range-container .span-disabled{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .action-button-container{display:flex;gap:var(--outline-offset4);height:36px}.sol-date-range-container .read-only{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);color:var(--color-interface-text800);cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .read-only:focus-within{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .read-only:hover{border-color:var(--color-globalstate-disabled-borderalt)}.sol-date-range-container .sol-date-range-input{height:100%;width:7.75rem;border-style:none;border-width:0;box-sizing:border-box;background-color:var(--color-button-basic-normal);outline:none;margin-left:var(--outline-offset4);font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);text-align:left;color:var(--color-interface-text700);display:flex}.sol-date-range-container .sol-date-range-input.with-time{width:13.75rem}.sol-date-range-container .sol-date-range-input:read-only{cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-date-range-container .sol-date-range-input:read-only::placeholder{color:var(--color-interface-text800)}.sol-date-range-container .sol-date-range-input:disabled{pointer-events:var(--typography-opensans-body-body1-text-case);background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-date-range-container .sol-date-range-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-date-range-container .error-message{color:var(--color-button-destructive-hover);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);margin-top:.4rem;display:block}.date-range-picker-wrapper-popover{background:var(--color-button-basic-normal);border:.0625rem solid var(--color-interface-border1);box-shadow:0 var(--outline-offset4) .375rem #0000003d;border-radius:var(--radii-small-allcorners)}.date-range-picker-wrapper .date-range-container{display:flex;position:relative;width:29rem}.date-range-picker-wrapper .date-range-container.no-leftpanel{width:20.5rem}.date-range-picker-wrapper .date-range-container.with-time{width:29.75rem}.date-range-picker-wrapper .date-range-container .list-container{display:flex;flex-direction:column;justify-content:space-between;width:8.5rem;border-right:.0625rem solid var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container{margin-top:.3125rem;margin-bottom:.3125rem}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements{padding-left:.3125rem;cursor:pointer}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .span-width{width:5.625rem;text-align:left}.date-range-picker-wrapper .date-range-container .list-container .list-sub-container .list-elements .today-span{width:5.625rem}.date-range-picker-wrapper .date-range-container .list-container hr{margin:0;border-style:solid;color:var(--color-interface-border1)}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper{width:20.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container{display:flex;font-family:var(--typography-opensans-body-body3-font-family);font-weight:700;font-size:.9375rem;margin:1.5rem;width:17.5rem;height:2.375rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .numeric-selector-container .inner-container-div{text-align:center;align-items:center;display:flex;padding:.5rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container{display:flex;position:absolute;bottom:1.25rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class{margin-left:.75rem}.date-range-picker-wrapper .date-range-container .sol-calender-wrapper .buttons-container .button-class .button-span-width{width:7.75rem}.date-range-picker-wrapper .date-range-time-container{width:28.75rem}.date-range-picker-wrapper .date-range-time-container .date-time-container{display:flex;position:relative}.date-range-picker-wrapper .date-range-time-container .date-time-container .calendar-container{width:17.5rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:.0625rem solid var(--color-interface-border1);width:10rem;padding:1.125rem}.date-range-picker-wrapper .date-range-time-container .date-time-container .timepicker-container .timepicker{height:100%}.date-range-picker-wrapper .date-range-time-container .footer{width:100%;border-top:.0625rem solid var(--color-interface-border1);display:inline-flex;justify-content:space-between;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .clear-button{display:inline-flex;margin:18px}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons{display:inline-flex;margin:1.125rem;gap:.75rem;flex-direction:row-reverse}.date-range-picker-wrapper .date-range-time-container .footer .footer-buttons .buttons-span{width:7.125rem}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.TranslationService
  }], {
    format: [{
      type: Input
    }],
    displayleftPanel: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    daysDisabled: [{
      type: Input
    }],
    specialDates: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    startingDay: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    showActionArrows: [{
      type: Input
    }],
    arrowPosition: [{
      type: Input
    }],
    calendarEl: [{
      type: ViewChild,
      args: [DateRangeWrapperComponent]
    }]
  });
})();
class DateRangepickerModule {
  static {
    this.ɵfac = function DateRangepickerModule_Factory(t) {
      return new (t || DateRangepickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DateRangepickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [languageInitializerProvider],
      imports: [CommonModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), CalendarModule, TextInputModule, NumericSelectorModule, ButtonModule, SvgSpriteIconModule, ButtonModule, TimePickerModule, TabsModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangepickerModule, [{
    type: NgModule,
    args: [{
      declarations: [DateRangePickerComponent, DateRangeWrapperComponent, DateRangePickerDirective],
      imports: [CommonModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), CalendarModule, TextInputModule, NumericSelectorModule, ButtonModule, SvgSpriteIconModule, ButtonModule, TimePickerModule, TabsModule, TranslationModule],
      providers: [languageInitializerProvider],
      exports: [DateRangePickerComponent, DateRangeWrapperComponent, DateRangePickerDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DateRangePickerComponent, DateRangePickerDirective, DateRangeWrapperComponent, DateRangepickerModule, TabState };
